import React__default from 'react';

var AccountSettings = function AccountSettings(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M15.89 20.07c-.19-.06-.37-.1-.57-.19-.2-.09-.35-.19-.53-.29h-.03l-1.39.63-1.13-1.58 1.03-1.2c-.11-.42-.16-.85-.13-1.29l-1.22-.91.8-1.83 1.5.28c.3-.32.65-.58 1.03-.76l.16-1.57 1.99-.25.44 1.48h.04c.19.06.37.1.57.19.2.09.35.19.52.29l.03.03 1.41-.65 1.12 1.58-1.04 1.2c.12.4.17.83.13 1.27l1.23.91-.8 1.83-1.51-.27c-.3.32-.65.58-1.04.78l-.18 1.56-1.93.24-.47-1.46h-.03v-.02Zm.17-1.94c1.01.46 2.2 0 2.65-.98.46-.99.03-2.19-.98-2.65-.99-.46-2.2 0-2.65.98-.46.99 0 2.2.98 2.65ZM12 13.01c-2.67 0-8 1.34-8 4v3h6.9v-1.9h-5v-1.1c0-.54 2.26-1.69 4.77-2.02L12 13.01Zm0-9c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 6.1c-1.16 0-2.1-.95-2.1-2.1 0-1.15.94-2.11 2.1-2.11 1.16 0 2.1.95 2.1 2.11a2.1 2.1 0 0 1-2.1 2.1Z"
  }));
};
AccountSettings.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var ActivateUser = function ActivateUser(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 6.1a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2Zm0 2.9c-2.67 0-8 1.34-8 4v3h7.9v-1.9h-6V17c0-.64 3.13-2.1 6.1-2.1 1.41 0 2.86.32 3.98.75l1.41-1.48C15.66 13.39 13.44 13 12 13ZM22 16.25l-5.78 5.79-2.78-2.79 1.41-1.41 1.37 1.37 4.37-4.37L22 16.25Z"
  }));
};
ActivateUser.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var AddToList = function AddToList(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M16.96 12c-1.86 0-3.43 1.27-3.87 3-.09.32-.13.65-.13 1s.04.68.13 1a3.999 3.999 0 0 0 7.87-1c0-2.21-1.79-4-4-4Zm1 5v2h-2v-2h-2v-2h2v-2h2v2h2v2h-2ZM6 11H4v2h2v-2ZM6 15H4v2h2v-2ZM6 7H4v2h2V7ZM13.65 11H8v2h3.77c.46-.8 1.11-1.49 1.88-2ZM20 7H8v2h12V7ZM11.05 15H8v2h3.05c-.05-.33-.09-.66-.09-1 0-.34.04-.67.09-1Z"
  }));
};
AddToList.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Admin = function Admin(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M18 13a4 4 0 1 0 4 4 4 4 0 0 0-4-4Zm0 1.38a1.12 1.12 0 0 1 0 2.24 1.12 1.12 0 0 1 0-2.24Zm0 5.36a2.72 2.72 0 0 1-2.24-1.17c.05-.71 1.51-1.07 2.24-1.07s2.18.36 2.23 1.07A2.71 2.71 0 0 1 18 19.72Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M11 22h-.2A11.35 11.35 0 0 1 2 11.17V5.59l9-3.67 9 3.67v5.65l-1.14-.17A5.83 5.83 0 0 0 18 11a6 6 0 0 0-6 6 5.89 5.89 0 0 0 .91 3.15l.66 1.07-1.19.4a10.24 10.24 0 0 1-1.15.34ZM4 6.94v4.23a9.3 9.3 0 0 0 6.49 8.63A7.91 7.91 0 0 1 10 17a8 8 0 0 1 8-8V6.94l-7-2.86Z"
  }));
};
Admin.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var LogOut = function LogOut(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M15 19H6V5h9v1.17l1.87-1.87V3H4v18H16.87v-1.3L15 17.82V19Z"
  }), React__default.createElement("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5Z"
  }));
};
LogOut.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Password = function Password(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M2 17h20v2H2Zm1.15-4L4 11.47 4.85 13l1.3-.75-.85-1.53H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48Zm6.7-.75 1.3.75.85-1.53.85 1.53 1.3-.75-.85-1.48H15V9.22h-1.7l.85-1.47-1.3-.75L12 8.47 11.15 7l-1.3.75.85 1.47H9v1.5h1.7ZM23 9.22h-1.7l.85-1.47-1.3-.75L20 8.47 19.15 7l-1.3.75.85 1.47H17v1.5h1.7l-.85 1.48 1.3.75.85-1.48.85 1.53 1.3-.75-.85-1.48H23Z"
  }));
};
Password.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Players = function Players(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M1 20v-2.8c0-.57.15-1.09.44-1.56.29-.47.68-.84 1.16-1.09 1.03-.52 2.08-.9 3.15-1.16a13.695 13.695 0 0 1 6.5 0c1.07.26 2.12.65 3.15 1.16.48.25.87.61 1.16 1.09.29.48.44 1 .44 1.56V20H1Zm18 0v-3c0-.73-.2-1.44-.61-2.11-.41-.67-.99-1.25-1.74-1.74a12.382 12.382 0 0 1 4.5 1.4c.6.33 1.06.7 1.38 1.11.32.41.48.85.48 1.34v3h-4ZM9 12c-1.1 0-2.04-.39-2.82-1.18C5.4 10.04 5 9.09 5 8s.39-2.04 1.18-2.82C6.96 4.4 7.9 4 9 4s2.04.39 2.82 1.18C12.6 5.96 13 6.9 13 8s-.39 2.04-1.18 2.82C11.04 11.6 10.09 12 9 12Zm6 0c-.18 0-.42-.02-.7-.06-.28-.04-.52-.09-.7-.14.45-.53.8-1.12 1.04-1.78.24-.65.36-1.32.36-2.02s-.12-1.38-.36-2.03c-.24-.65-.59-1.24-1.04-1.78.23-.08.47-.14.7-.16.23-.02.47-.04.7-.04 1.1 0 2.04.39 2.83 1.18.78.78 1.17 1.72 1.17 2.82s-.39 2.04-1.17 2.82c-.78.78-1.73 1.18-2.83 1.18ZM3 18h12v-.8c0-.18-.05-.35-.14-.5a.93.93 0 0 0-.36-.35c-.9-.45-1.81-.79-2.73-1.01C10.85 15.12 9.93 15 9 15s-1.86.11-2.78.34c-.92.23-1.82.56-2.72 1.01a.93.93 0 0 0-.36.35c-.09.15-.14.32-.14.5v.8Zm6-8c.55 0 1.02-.2 1.41-.59.39-.39.59-.86.59-1.41s-.2-1.02-.59-1.41S9.55 6 9 6s-1.02.2-1.41.59C7.2 6.98 7 7.45 7 8s.2 1.02.59 1.41c.39.39.86.59 1.41.59Zm0 8ZM9 8Z"
  }));
};
Players.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Profile = function Profile(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 5.9A2.1 2.1 0 1 1 9.9 8 2.1 2.1 0 0 1 12 5.9m0 9c3 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4a4 4 0 1 0 4 4 4 4 0 0 0-4-4Zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4Z"
  }));
};
Profile.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Settings = function Settings(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m9.3 22.02-.4-3.2c-.22-.08-.42-.18-.61-.3s-.38-.24-.56-.38l-2.98 1.25L2 14.64l2.57-1.95c-.02-.12-.02-.23-.02-.34v-.68c0-.11 0-.22.03-.34L2 9.38l2.75-4.75 2.97 1.25c.18-.13.38-.26.58-.38.2-.12.4-.22.6-.3L9.3 2h5.5l.4 3.2c.22.08.42.18.61.3s.38.24.56.38l2.98-1.25 2.75 4.75-2.58 1.95c.02.12.02.23.02.34v.68c0 .11-.02.22-.05.34l2.58 1.95-2.75 4.75-2.95-1.25c-.18.13-.37.26-.57.38-.2.12-.4.22-.6.3l-.4 3.2H9.3Zm2.8-6.5c.97 0 1.79-.34 2.47-1.02a3.39 3.39 0 0 0 1.03-2.48c0-.97-.34-1.79-1.02-2.48-.68-.68-1.51-1.02-2.48-1.02s-1.81.34-2.49 1.02c-.67.68-1.01 1.51-1.01 2.48s.34 1.79 1.01 2.48c.68.68 1.5 1.02 2.49 1.02Zm0-2c-.42 0-.77-.15-1.06-.44-.29-.29-.44-.65-.44-1.06 0-.41.15-.77.44-1.06.29-.29.65-.44 1.06-.44.41 0 .77.15 1.06.44.29.29.44.65.44 1.06 0 .41-.15.77-.44 1.06-.29.29-.65.44-1.06.44Zm-1.05 6.5h1.98l.35-2.65c.52-.13 1-.33 1.44-.59.44-.26.85-.57 1.21-.94l2.48 1.02.98-1.7-2.15-1.62c.08-.23.14-.48.17-.74s.05-.52.05-.79-.02-.53-.05-.79c-.03-.26-.09-.5-.17-.74l2.15-1.62-.98-1.7-2.48 1.05c-.37-.38-.77-.7-1.21-.96-.44-.26-.92-.45-1.44-.59l-.33-2.65h-1.98l-.35 2.65c-.52.13-1 .33-1.44.59-.44.26-.85.57-1.21.94L5.6 7.16l-.97 1.7 2.15 1.6c-.08.25-.14.5-.18.75-.03.25-.05.52-.05.8 0 .27.02.52.05.77.03.25.09.5.18.75l-2.15 1.62.97 1.7 2.47-1.05c.37.38.77.7 1.21.96.44.26.92.45 1.44.59l.32 2.65.01.02Z"
  }));
};
Settings.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Squad = function Squad(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 11.14c1.55 0 2.81-1.26 2.81-2.81S13.55 5.52 12 5.52 9.19 6.78 9.19 8.33s1.26 2.81 2.81 2.81Zm0-3.82c.56 0 1.01.45 1.01 1.01S12.56 9.34 12 9.34s-1.01-.45-1.01-1.01.45-1.01 1.01-1.01ZM5 11.98c1.5 0 2.72-1.23 2.72-2.74C7.72 7.73 6.5 6.5 5 6.5c-1.5 0-2.72 1.23-2.72 2.74 0 1.51 1.22 2.74 2.72 2.74Zm0-3.73c.54 0 .97.44.97.99s-.44.99-.97.99-.97-.44-.97-.99.44-.99.97-.99ZM19 12.14c1.5 0 2.72-1.23 2.72-2.74 0-1.51-1.22-2.74-2.72-2.74-1.5 0-2.72 1.23-2.72 2.74 0 1.51 1.22 2.74 2.72 2.74Zm0-3.73c.54 0 .97.44.97.99s-.44.99-.97.99-.97-.44-.97-.99.44-.99.97-.99ZM18.75 13.17c-1.03 0-1.8.21-2.36.45-.8-.84-2.36-1.52-4.35-1.52-1.99 0-3.6.68-4.42 1.53-.56-.24-1.33-.45-2.36-.45-2.42 0-4.1 1.22-4.1 2.32v3H11v-1.7H8.81v-1.82c.21-.32 1.27-1.07 3.23-1.07s2.96.75 3.15 1.06v1.83H13v1.7h9.84v-3c0-1.1-1.68-2.32-4.1-2.32l.01-.01ZM2.86 16.78v-1.16c.18-.2.91-.75 2.4-.75.82 0 1.39.17 1.75.34v1.57H2.86Zm18.29 0H17v-1.57c.36-.17.93-.34 1.75-.34 1.49 0 2.22.55 2.4.75v1.16Z"
  }));
};
Squad.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Apps = function Apps(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M14 4h-4v4h4V4ZM8 4H4v4h4V4ZM14 10h-4v4h4v-4ZM8 10H4v4h4v-4ZM14 16h-4v4h4v-4ZM20 4h-4v4h4V4ZM20 10h-4v4h4v-4ZM20 16h-4v4h4v-4ZM8 16H4v4h4v-4Z"
  }));
};
Apps.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var BackArrow = function BackArrow(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M10.62 7.99 4.6 11.96l5.98 4.03.02-3.02 9.99.05.02-2.04-9.99-.05.02-2.95-.02.01Z"
  }));
};
BackArrow.defaultProps = {
  viewBox: "0 0 25 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronDown = function ChevronDown(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6Z"
  }));
};
ChevronDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ChevronLeft = function ChevronLeft(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6Z"
  }));
};
ChevronLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ChevronRight = function ChevronRight(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6Z"
  }));
};
ChevronRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ChevronUp = function ChevronUp(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14Z"
  }));
};
ChevronUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Close = function Close(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12Z"
  }));
};
Close.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var CloseFullscreen = function CloseFullscreen(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M5 16h3v3h2v-5H5Zm3-8H5v2h5V5H8Zm6 11h2v-3h3v-2h-5Zm2-11V5h-2v5h5V8Z"
  }));
};
CloseFullscreen.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var CloseSolid = function CloseSolid(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12Z"
  }));
};
CloseSolid.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Collapse = function Collapse(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M7.41 18.59 8.83 20 12 16.83 15.17 20l1.41-1.41L12 14Zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10Z"
  }));
};
Collapse.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var DoubleChevronLeft = function DoubleChevronLeft(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M17.14 7.41 12.56 12l4.58 4.59L15.73 18l-6-6 6-6 1.41 1.41Z"
  }), React__default.createElement("path", {
    d: "M12.14 7.41 7.56 12l4.58 4.59L10.73 18l-6-6 6-6 1.41 1.41Z"
  }));
};
DoubleChevronLeft.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var DoubleChevronRight = function DoubleChevronRight(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M6.73 16.59 11.31 12 6.73 7.41 8.14 6l6 6-6 6-1.41-1.41Z"
  }), React__default.createElement("path", {
    d: "M11.73 16.59 16.31 12l-4.58-4.59L13.14 6l6 6-6 6-1.41-1.41Z"
  }));
};
DoubleChevronRight.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var DragHandle = function DragHandle(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M17 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM11 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM17 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM11 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM17 18a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM11 18a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
  }));
};
DragHandle.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var EnterFullscreen = function EnterFullscreen(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M7 14H5v5h5v-2H7Zm-2-4h2V7h3V5H5Zm12 7h-3v2h5v-5h-2ZM14 5v2h3v3h2V5Z"
  }));
};
EnterFullscreen.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Erase = function Erase(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M17.25 18H22v2h-6.75l2-2Zm-12.5 2L1.2 16.45 15 2.15l7.8 7.8L13 20H4.75Zm7.4-2L20 9.95 15.05 5 4 16.4 5.6 18h6.55Z"
  }));
};
Erase.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Expand = function Expand(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9Zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15Z"
  }));
};
Expand.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var First = function First(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M5.8 18V6h2v12h-2Zm11 0-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6-1.4 1.4Z"
  }));
};
First.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ForwardArrow = function ForwardArrow(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M13.984 15.99 20 12.025 14.024 8l-.02 3.016-9.984-.05L4 13.004l9.984.05-.02 2.946.02-.01Z"
  }));
};
ForwardArrow.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HamburgerMenu = function HamburgerMenu(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M3 17h18v-2H3v2Zm0-4h18v-2H3v2Zm0-6v2h18V7H3Z"
  }));
};
HamburgerMenu.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Handle = function Handle(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M17 9H7v2h10ZM7 15h10v-2H7Z"
  }));
};
Handle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Home = function Home(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4 21V9l8-6 8 6v12h-6v-7h-4v7H4Zm2-2h2v-7h8v7h2v-9l-6-4.5L6 10v9Z"
  }));
};
Home.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Info = function Info(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M13 17h-2v-6h2Zm0-8h-2V7h2Z"
  }));
};
Info.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Key = function Key(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M21 10h-8.35a6 6 0 1 0 0 4H13l2 2 2-2 2 2 4-4ZM7 15a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
  }));
};
Key.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var LanguageWorld = function LanguageWorld(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm6.93 6H16a15.65 15.65 0 0 0-1.38-3.56A8 8 0 0 1 18.92 8ZM12 4a14.09 14.09 0 0 1 1.91 4h-3.82A14.09 14.09 0 0 1 12 4ZM4.26 14a7.82 7.82 0 0 1 0-4h3.38a16.52 16.52 0 0 0-.14 2 16.52 16.52 0 0 0 .14 2Zm.82 2H8a15.65 15.65 0 0 0 1.38 3.56A8 8 0 0 1 5.08 16ZM8 8H5.08a8 8 0 0 1 4.33-3.56A15.65 15.65 0 0 0 8 8Zm4 12a14.09 14.09 0 0 1-1.91-4h3.82A14.09 14.09 0 0 1 12 20Zm2.34-6H9.66a14.71 14.71 0 0 1-.16-2 14.58 14.58 0 0 1 .16-2h4.68a14.58 14.58 0 0 1 .16 2 14.71 14.71 0 0 1-.16 2Zm.25 5.56A15.65 15.65 0 0 0 16 16h3a8 8 0 0 1-4.41 3.56ZM16.36 14a16.52 16.52 0 0 0 .14-2 16.52 16.52 0 0 0-.14-2h3.38a7.82 7.82 0 0 1 0 4Z"
  }));
};
LanguageWorld.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Last = function Last(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M18.2 6v12h-2V6h2Zm-11 0 6 6-6 6-1.4-1.4 4.6-4.6-4.6-4.6L7.2 6Z"
  }));
};
Last.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Loading = function Loading(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M6 2v6l4 4-4 4v6h12v-6l-4-4 4-4V2Zm10 14.5V20H8v-3.5l4-4Zm-4-5-4-4V4h8v3.5Z"
  }));
};
Loading.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Lock = function Lock(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M18 10.99h-2v-3.1c0-2.05-1.93-4-4-4-2.07 0-4 1.95-4 4v3.1H6.01S6 10.99 6 11v9h11.99s.01 0 .01-.01v-9Zm-8-3.1c0-1.24.76-2 2-2s2 .76 2 2v3.1h-4v-3.1ZM16 18H8v-4.93h8V18Z"
  }));
};
Lock.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Minus = function Minus(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4 13v-2h16v2H4Z"
  }));
};
Minus.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var More = function More(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 8a2 2 0 1 0-2-2 2 2 0 0 0 2 2Zm0 2a2 2 0 1 0 2 2 2 2 0 0 0-2-2Zm0 6a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
  }));
};
More.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Pegman = function Pegman(props) {
  return React__default.createElement("svg", props, React__default.createElement("circle", {
    cx: "11.08",
    cy: "3.03",
    fill: "#fdbe2b",
    r: "2.74",
    style: {
      strokeWidth: ".14"
    }
  }), React__default.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: "72",
    y: "14",
    width: "41",
    height: "40"
  }, React__default.createElement("circle", {
    cx: "92.12",
    cy: "33.99",
    r: "19.99",
    fill: "#e58c2f"
  })), React__default.createElement("g", {
    mask: "url(#a)",
    transform: "matrix(.14 0 0 .14 -1.55 -1.63)"
  }, React__default.createElement("path", {
    d: "M89.97 52.58c-18.23-8-14.79-26.26-10.79-34.38l-5.6-5.2-18.39 5.2L46 38.98l51.57 29.19c5.06-1.87 10.63-7.6-7.6-15.59Z",
    fill: "#e58c2f"
  })), React__default.createElement("path", {
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M8.56 6.87h5.26v7.67H8.56z"
  }), React__default.createElement("path", {
    fill: "#e58c2f",
    style: {
      strokeWidth: ".14"
    },
    d: "M8.46 6.87h.27v7.95h-.27z"
  }), React__default.createElement("path", {
    transform: "rotate(15)",
    fill: "#e58c2f",
    style: {
      strokeWidth: ".14"
    },
    d: "M11.96 11.78h.53v4.74h-.53z"
  }), React__default.createElement("path", {
    transform: "rotate(-30)",
    fill: "#e58c2f",
    style: {
      strokeWidth: ".14"
    },
    d: "M2.86 19.84h.45v3.75h-.45z"
  }), React__default.createElement("path", {
    transform: "rotate(-45)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M3.24 14.6h1.64v4.86H3.24z"
  }), React__default.createElement("path", {
    d: "M17.08 8.11a.82.82 0 0 1 1.16 1.16l-2.16 2.16-1.16-1.16zM8.33 11.07c.33.33.33.86 0 1.19-.33.33-.86.33-1.19 0l-2.11-2.11 1.19-1.19z",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    }
  }), React__default.createElement("path", {
    transform: "rotate(-135)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M-12.38-3.62h1.64v4.64h-1.64z"
  }), React__default.createElement("path", {
    transform: "rotate(150)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M-4.7-23.73h1.64v4.23H-4.7z"
  }), React__default.createElement("path", {
    transform: "rotate(15)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M12.27 11.72h1.66v5.19h-1.66z"
  }), React__default.createElement("path", {
    transform: "rotate(90)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M14.54-13.82h1.64V-9h-1.64z"
  }), React__default.createElement("path", {
    d: "M6.04 20.21a.778.778 0 0 1-.56-.96c.11-.42.54-.67.97-.56l2.77.74-.41 1.52zM14.4 20.88c-.23.41-.75.54-1.16.31a.848.848 0 0 1-.31-1.16l1.54-2.67 1.47.85z",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    }
  }), React__default.createElement("path", {
    transform: "rotate(-90)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M-8.07 8.32h1.21v3.89h-1.21z"
  }), React__default.createElement("path", {
    d: "m11.19 9.39-.95-2.55h1.9z",
    fill: "#e58c2f",
    style: {
      strokeWidth: ".14"
    }
  }), React__default.createElement("circle", {
    cx: "17.58",
    cy: "22.02",
    fill: "#fdbe2b",
    r: "1.71",
    style: {
      strokeWidth: ".14"
    }
  }));
};
Pegman.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PegmanPickedUp = function PegmanPickedUp(props) {
  return React__default.createElement("svg", props, React__default.createElement("ellipse", {
    cx: "12",
    cy: "3.4",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    rx: "2.7",
    ry: "2.8"
  }), React__default.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: "72",
    y: "14",
    width: "41",
    height: "40"
  }, React__default.createElement("circle", {
    cx: "92",
    cy: "34",
    r: "20",
    fill: "#e58c2f"
  })), React__default.createElement("g", {
    mask: "url(#a)",
    transform: "matrix(.14 0 0 .14 -1 -1.4)"
  }, React__default.createElement("path", {
    d: "M90 52.6c-18.3-8-14.8-26.3-10.8-34.4L73.6 13l-18.4 5.2L46 39l51.6 29.2c5-1.9 10.6-7.6-7.6-15.6Z",
    fill: "#e58c2f"
  })), React__default.createElement("path", {
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M9.4 7.3h5.2v7.8H9.4z"
  }), React__default.createElement("path", {
    fill: "#e58c2f",
    style: {
      strokeWidth: ".14"
    },
    d: "M9.3 7.3h.27v8.1H9.3z"
  }), React__default.createElement("path", {
    transform: "rotate(11.5) skewX(.6)",
    fill: "#e58c2f",
    style: {
      strokeWidth: ".14"
    },
    d: "M12 13.1h.52v7H12z"
  }), React__default.createElement("path", {
    transform: "rotate(-149.3) skewX(1.3)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M-17.5-1.5h1.63v7.1h-1.63z"
  }), React__default.createElement("path", {
    transform: "matrix(.86 -.51 -.49 -.87 0 0)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M3.5-13.6h1.63v7.1H3.5z"
  }), React__default.createElement("path", {
    d: "M16.2 1.3c0-.46.36-.84.81-.84.45 0 .81.38.81.84v2.8H16.2zM7.8 1.3c0-.46-.36-.84-.81-.84-.45 0-.81.38-.81.84v2.65H7.8ZM9.6 15.1l1.58.44-1.83 7.05c-.05.41-.52.68-.95.55-.4-.14-.7-.58-.58-1.04ZM12.95 15.4h1.63v7.3c0 .47-.37.84-.82.84-.45 0-.82-.37-.82-.84z",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    }
  }), React__default.createElement("path", {
    transform: "rotate(90)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M15.1-14.6h1.67v4.76H15.1z"
  }), React__default.createElement("path", {
    transform: "rotate(-90)",
    fill: "#fdbe2b",
    style: {
      strokeWidth: ".14"
    },
    d: "M-8.52 9.15h1.23v3.84h-1.23z"
  }), React__default.createElement("path", {
    d: "m12 9.9-.95-2.63h1.87z",
    fill: "#e58c2f",
    style: {
      strokeWidth: ".14"
    }
  }));
};
PegmanPickedUp.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlayerList = function PlayerList(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M8 22h12v-2H8v2Zm0-6v2h12v-2H8ZM4 22h2v-2H4v2Zm0-6v2h2v-2H4ZM12 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 6.75c-2.002 0-6 1.005-6 3V13h12v-.25c0-1.995-3.998-3-6-3Z"
  }));
};
PlayerList.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Playlist = function Playlist(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m18 8-9 5V3l9 5ZM8 22h12v-2H8v2Zm0-6v2h12v-2H8ZM4 22h2v-2H4v2Zm0-6v2h2v-2H4Z"
  }));
};
Playlist.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PlusAdd = function PlusAdd(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6Z"
  }));
};
PlusAdd.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PlusSolid = function PlusSolid(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2Zm1 16.07h-1.99v-5.08H5.93V11h5.08V5.93H13v5.08h5.08V13H13v5.08-.01Z"
  }));
};
PlusSolid.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Redo = function Redo(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M7.667 5.333c1.692 0 3.327.617 4.6 1.734l2.4-2.4v6h-6l2.413-2.414a5.333 5.333 0 0 0-8.48 2.414l-1.58-.52a7.007 7.007 0 0 1 6.646-4.814Z"
  }));
};
Redo.defaultProps = {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};
var Refresh = function Refresh(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M17.65 6.35A8 8 0 1 0 19.73 14h-2.08A6 6 0 1 1 12 6a5.91 5.91 0 0 1 4.22 1.78L13 11h7V4Z"
  }));
};
Refresh.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Remove = function Remove(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12.04 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm5.45 10.91H6.58v-1.82h10.91v1.82Z"
  }));
};
Remove.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Reset = function Reset(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M6.348 6.352a7.99 7.99 0 0 1 13.05 2.604 8.008 8.008 0 0 1-2.556 9.415 7.987 7.987 0 0 1-12.572-4.37h2.078a6 6 0 0 0 4.83 3.944 5.989 5.989 0 0 0 5.717-2.482 6.004 6.004 0 0 0-1.785-8.59 5.99 5.99 0 0 0-3.118-.871 5.9 5.9 0 0 0-4.216 1.78l3.217 3.22H4v-7l2.348 2.35Z"
  }));
};
Reset.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Search = function Search(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m20.49 19-5.73-5.74A6.37 6.37 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16a6.42 6.42 0 0 0 3.77-1.24L19 20.49Zm-11-5A4.5 4.5 0 1 1 14 9.5 4.49 4.49 0 0 1 9.5 14Z"
  }));
};
Search.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var StarFilled = function StarFilled(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 17.27 18.18 21l-1.64-7L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24 7.46 14l-1.64 7Z"
  }));
};
StarFilled.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Start = function Start(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M2 18V6h2v12H2Zm14 0-1.43-1.4 3.6-3.6H6v-2h12.17L14.6 7.4 16 6l6 6-6 6Z"
  }));
};
Start.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var StarUnfilled = function StarUnfilled(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24 7.46 14l-1.64 7L12 17.27 18.18 21l-1.63-7ZM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38 1.7-4 1.71 4 4.38.38-3.32 2.89 1 4.28Z"
  }));
};
StarUnfilled.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var TickDone = function TickDone(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2Z"
  }));
};
TickDone.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ThumbUp = function ThumbUp(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M7 10v12M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
  }));
};
ThumbUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-thumbs-up h-4 w-4"
};
var ThumbDown = function ThumbDown(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M17 14V2M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"
  }));
};
ThumbDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-thumbs-down"
};
var Undo = function Undo(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12.5 8a10.46 10.46 0 0 0-6.9 2.6L2 7v9h9l-3.62-3.62A8 8 0 0 1 20.1 16l2.37-.78A10.51 10.51 0 0 0 12.5 8Z"
  }));
};
Undo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Unlock = function Unlock(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M6.01 11.04 6 9.05v11h11.99s.01 0 .01-.01v-9h-2v-3.1c0-2.05-1.93-4-4-4-2.07 0-4 1.95-4 4v1.1h2v-1.1c0-1.24.76-2 2-2s2 .76 2 2v3.1H6.01ZM16 18.05H8v-4.93h8v4.93Z"
  }));
};
Unlock.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Warning = function Warning(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M16.14 2H7.86L2 7.86v8.28L7.86 22h8.28L22 16.14V7.86ZM13 17h-2v-2h2Zm0-4h-2V7h2Z"
  }));
};
Warning.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Cursor = function Cursor(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M8 13.75 9.975 11h4.25L8 6.1v7.65ZM13.775 22l-3.625-7.8L6 20V2l14 11h-7.1l3.6 7.725L13.775 22Z"
  }));
};
Cursor.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Crosshair = function Crosshair(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M17.5 14.5V11h-3v3.5H11v3h3.5V21h3v-3.5H21v-3h-3.5Zm2.5 2h-3.5V20h-1v-3.5H12v-1h3.5V12h1v3.5H20v1Z",
    fill: "#fff"
  }), React__default.createElement("path", {
    d: "M16 32C7.18 32 0 24.82 0 16S7.18 0 16 0s16 7.18 16 16-7.18 16-16 16Zm0-31C7.73 1 1 7.73 1 16s6.73 15 15 15 15-6.73 15-15S24.27 1 16 1Z",
    fill: "#121212"
  }), React__default.createElement("path", {
    fill: "#121212",
    d: "M20 15.5v1h-3.5V20h-1v-3.5H12v-1h3.5V12h1v3.5H20z"
  }));
};
Crosshair.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
};
var ScheduleCalendarView = function ScheduleCalendarView(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M20.5 6h-17v12h17V6Zm-12 5h-3V8h3v3Zm5 0h-3V8h3v3Zm5 0h-3V8h3v3Zm-10 5h-3v-3h3v3Zm5 0h-3v-3h3v3Zm5 0h-3v-3h3v3Z"
  }));
};
ScheduleCalendarView.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Checklist = function Checklist(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 15H4v2h8v-2ZM10 11H4v2h6v-2ZM12 7H4v2h8V7ZM14.88 15.61l-2.85-2.81 1.41-1.41 1.41 1.41 3.73-3.72L20 10.49l-5.12 5.12Z"
  }));
};
Checklist.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Dashboard = function Dashboard(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M5 12h6V4H5v8Zm0 7h6v-5H5v5Zm8 0h6v-8h-6v8Zm0-15v5h6V4h-6Z"
  }));
};
Dashboard.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Date = function Date(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M8.99 11h-2v2h2v-2Zm4 0h-2v2h2v-2Zm4 0h-2v2h2v-2Zm1-7V2h-2v2h-8V2h-2v2H3v18h17.99V4h-3Zm1 16h-14V9h14v11Z"
  }));
};
Date.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var ListItems = function ListItems(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M5.04 5h14v6h-14V5Zm2 4h10V7h-10v2Zm-2 4h14v6h-14v-6Zm2 4h10v-2h-10v2Z"
  }));
};
ListItems.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var ListView = function ListView(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4.04 13h2v-2h-2v2Zm0 4h2v-2h-2v2Zm0-8h2V7h-2v2Zm4 4h12v-2h-12v2Zm0 4h12v-2h-12v2Zm0-10v2h12V7h-12Z"
  }));
};
ListView.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var PopoutVideo = function PopoutVideo(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 8v4l4-2-4-2Z"
  }), React__default.createElement("path", {
    d: "M22 16H6V4h16v12ZM8 14h12V6H8v8Z"
  }), React__default.createElement("path", {
    d: "M4 18V8H2v12h16v-2H4Z"
  }));
};
PopoutVideo.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Reorder = function Reorder(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 7v2h-2c-.82 0-1.58.34-2.12.88S7 11.18 7 12c0 1.65 1.35 3 3 3v2c-.35 0-.69-.03-1.01-.1-.48-.1-.94-.27-1.37-.5-.42-.24-.81-.53-1.15-.87-.09-.09-.18-.19-.25-.29-.09-.07-.15-.16-.21-.25-.08-.1-.15-.21-.22-.31-.27-.41-.47-.85-.59-1.33-.1-.3-.16-.61-.18-.94-.01-.15-.02-.31-.02-.46.01-1.36.57-2.58 1.47-3.48C7.38 7.56 8.62 7 10 7h2ZM20 7h-6v2h6V7ZM20 10.88h-6V13h6v-2.12ZM20 15h-6v2h6v-2Z"
  }), React__default.createElement("path", {
    d: "m12 16-2 2v-4l2 2Z"
  }));
};
Reorder.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Replace = function Replace(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m4.31 14.11 1.86-.76c-.53-2.47.55-5.12 2.85-6.46a5.934 5.934 0 0 1 5.73-.15l-1.14 1.52h5l-1.41-4.8-1.24 1.66c-2.39-1.35-5.4-1.44-7.94.04a7.963 7.963 0 0 0-3.71 8.94v.01ZM19.75 9.97c.94 3.41-.48 7.15-3.69 9.02a7.922 7.922 0 0 1-8 0l-1.24 1.64-1.4-4.81h5l-1.17 1.55c1.77.94 3.95.95 5.8-.12 2.33-1.35 3.4-4.04 2.83-6.53l1.86-.75h.01Z"
  }));
};
Replace.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var ResetZoom = function ResetZoom(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M15.02 14.03c.77-1.07 1.24-2.36 1.24-3.76a6.5 6.5 0 0 0-6.5-6.5c-1.53 0-2.94.53-4.05 1.42L3.26 2.74v5.95h5.95L7.15 6.63a4.49 4.49 0 0 1 2.62-.86c2.49 0 4.5 2.01 4.5 4.5s-2.01 4.5-4.5 4.5c-2.34 0-4.24-1.79-4.46-4.08H3.28c.22 3.39 3.03 6.08 6.48 6.08 1.41 0 2.7-.47 3.77-1.24l5.73 5.73 1.49-1.49-5.73-5.74Z"
  }));
};
ResetZoom.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Rotate = function Rotate(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M19 8.02v-4h-9v4h9Zm-15 2v9h4v-9H4Zm0-6v4h4v-4H4Zm11.84 4.73-3.16 3.17h2.37v3.16h-3.18l.02-2.37-3.16 3.16 3.16 3.16-.02-2.36h4.75v-4.75h2.37l-3.16-3.16.01-.01Z"
  }));
};
Rotate.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var RotateLeft = function RotateLeft(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m5.64 13.98-2.83 2.83v-9.9h9.9l-2.9 2.9c3.54 3.54 7.14 4.88 11.38 4.17v2c-3.88 1.84-10.87 1.52-15.56-2Z"
  }));
};
RotateLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var RotateRight = function RotateRight(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m18.36 13.98 2.83 2.83v-9.9h-9.9l2.9 2.9c-3.54 3.54-7.14 4.88-11.38 4.17v2c3.88 1.84 10.87 1.52 15.56-2Z"
  }));
};
RotateRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var SwapOrientation = function SwapOrientation(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M11 13H4v8h12v-3h-2v1H6v-4h5Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M21 4h-8v12h8Zm-6 10V6h4v8ZM6 9a3 3 0 0 1 3-3V4a5 5 0 0 0-5 5ZM9 8.06V1.98l3.04 3.04L9 8.06z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M1.96 8.98h6.08L5 12.02 1.96 8.98z"
  }));
};
SwapOrientation.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Swap = function Swap(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m7 11-4 4 4 4v-3h7v-2H7Zm14-2-4-4v3h-7v2h7v3Z"
  }));
};
Swap.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var TiltDown = function TiltDown(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m15 14.25-2-11h-2l-2 11H5.5l6.5 6.5 6.5-6.5H15z"
  }));
};
TiltDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var TiltUp = function TiltUp(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m12 3.25-6.5 6.5H9l2 11h2l2-11h3.5L12 3.25z"
  }));
};
TiltUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var TrimArea = function TrimArea(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M6.85 3.88H17v2H6.85zM3.01 8h2v8h-2zM19 8h2v8h-2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M7 8H1V2h6v6ZM3 6h2V4H3v2Z"
  }), React__default.createElement("path", {
    d: "M23 8h-6V2h6v6Zm-4-2h2V4h-2v2ZM7 22H1v-6h6v6Zm-4-2h2v-2H3v2Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M23 22h-6v-6h6v6Zm-4-2h2v-2h-2v2Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M6.92 18h10.15v2H6.92zM15.99 9v6H8V9h7.99Zm-6 4h4.02v-2H9.99v2Z"
  }));
};
TrimArea.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Visibility = function Visibility(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M8 0C4.667 0 1.82 2.073.667 5c1.153 2.927 4 5 7.333 5s6.18-2.073 7.333-5c-1.153-2.927-4-5-7.333-5Zm0 8.333a3.335 3.335 0 0 1 0-6.666A3.335 3.335 0 0 1 11.333 5 3.335 3.335 0 0 1 8 8.333ZM8 3c-1.107 0-2 .893-2 2s.893 2 2 2 2-.893 2-2-.893-2-2-2Z"
  }));
};
Visibility.defaultProps = {
  viewBox: "0 0 16 10",
  xmlns: "http://www.w3.org/2000/svg"
};
var ZoomIn = function ZoomIn(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m20.92 19.58-6.21-6.21A6.429 6.429 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.41 0 2.72-.46 3.79-1.22L19.51 21l1.41-1.41v-.01ZM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
  }), React__default.createElement("path", {
    d: "M12.5 10.5h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2Z"
  }));
};
ZoomIn.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var ZoomOut = function ZoomOut(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m20.92 19.58-6.21-6.21A6.429 6.429 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.41 0 2.72-.46 3.79-1.22L19.51 21l1.41-1.41v-.01ZM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
  }), React__default.createElement("path", {
    d: "M12.5 10.5h-6v-2h6v2Z"
  }));
};
ZoomOut.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var DisplaySettings = function DisplaySettings(props) {
  return React__default.createElement("svg", props, React__default.createElement("defs", null, React__default.createElement("style", null, ".cls-1", "{", "stroke-width:0", "}")), React__default.createElement("path", {
    className: "cls-1",
    d: "m20.5 12.03-.23 1.95-1.23.15V16h-14V7h4.85l-.3-.22.78-1.78H3.04v13h6v2h6v-2h6v-5.87l-.54-.1z"
  }), React__default.createElement("path", {
    className: "cls-1",
    d: "M16.03 10.95c-.19-.06-.37-.1-.57-.19s-.35-.19-.53-.29h-.03l-1.39.63-1.13-1.58 1.03-1.2c-.11-.42-.16-.85-.13-1.29l-1.22-.91.8-1.83 1.5.28c.3-.32.65-.58 1.03-.76l.16-1.57 1.99-.25.44 1.48h.04c.19.06.37.1.57.19s.35.19.52.29l.03.03 1.41-.65 1.12 1.58-1.04 1.2c.12.4.17.83.13 1.27l1.23.91-.8 1.83-1.51-.27c-.3.32-.65.58-1.04.78l-.18 1.56-1.93.24-.47-1.46h-.03Zm.18-1.92c1.01.46 2.2 0 2.65-.98.46-.99.03-2.19-.98-2.65-.99-.46-2.2 0-2.65.98-.46.99 0 2.2.98 2.65Z"
  }));
};
DisplaySettings.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Mode = function Mode(props) {
  return React__default.createElement("svg", props, React__default.createElement("defs", null, React__default.createElement("style", null, ".cls-1", "{", "stroke-width:0", "}")), React__default.createElement("path", {
    className: "cls-1",
    d: "M4.54 8c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5Zm3.5 1.17c-.64 0-1.17-.52-1.17-1.17 0-.64.52-1.17 1.17-1.17.64 0 1.17.52 1.17 1.17 0 .64-.52 1.17-1.17 1.17ZM5.04 13v6h6v-6h-6Zm4 4h-2v-2h2v2ZM13.06 13v6h6v-6h-6Zm4 4h-2v-2h2v2ZM13.01 5.03l.05 6 6-.05-.05-6-6 .05Zm4.04 3.96-2 .02-.02-2 2-.02.02 2Z"
  }));
};
Mode.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var BallBasketball = function BallBasketball(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4.05 11H6.9a5.801 5.801 0 0 0-1.65-3.25c-.3.48-.55 1-.76 1.54-.21.54-.35 1.11-.44 1.71Zm13.05 0h2.85c-.08-.6-.23-1.17-.44-1.71s-.46-1.05-.76-1.54c-.43.43-.79.93-1.08 1.48A5.65 5.65 0 0 0 17.1 11ZM5.25 16.25c.43-.43.79-.93 1.07-1.48.28-.55.47-1.14.58-1.77H4.05c.08.6.23 1.17.44 1.71s.46 1.05.76 1.54Zm13.5 0c.3-.48.55-1 .76-1.54.21-.54.35-1.11.44-1.71H17.1c.1.63.29 1.22.58 1.77s.64 1.04 1.07 1.48ZM8.95 11H11V4.05c-.88.13-1.7.38-2.46.74S7.1 5.62 6.5 6.2a8.34 8.34 0 0 1 1.61 2.16c.42.81.7 1.69.84 2.64ZM13 11h2.05c.13-.95.41-1.83.84-2.64.42-.81.96-1.53 1.61-2.16-.6-.58-1.28-1.05-2.04-1.41-.76-.36-1.58-.6-2.46-.74V11Zm-2 8.95V13H8.95c-.13.95-.41 1.83-.84 2.64s-.96 1.53-1.61 2.16c.6.58 1.28 1.05 2.04 1.41.76.36 1.58.6 2.46.74Zm2 0c.88-.13 1.7-.38 2.46-.74s1.44-.83 2.04-1.41a8.34 8.34 0 0 1-1.61-2.16c-.43-.81-.7-1.69-.84-2.64H13v6.95ZM12 22c-1.38 0-2.68-.26-3.9-.79a10.12 10.12 0 0 1-3.18-2.14c-.9-.9-1.61-1.96-2.14-3.18a9.678 9.678 0 0 1-.79-3.9c0-1.38.26-2.68.79-3.9a10.12 10.12 0 0 1 2.14-3.18c.9-.9 1.96-1.61 3.18-2.14a9.85 9.85 0 0 1 3.9-.79c1.38 0 2.68.26 3.9.79 1.22.53 2.28 1.24 3.17 2.14.9.9 1.61 1.96 2.14 3.18.53 1.22.79 2.52.79 3.9s-.26 2.68-.79 3.9a9.853 9.853 0 0 1-2.14 3.17c-.9.9-1.96 1.61-3.18 2.14-1.22.53-2.52.79-3.9.79L12 22Z"
  }));
};
BallBasketball.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var BallFootballCollege = function BallFootballCollege(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M20.31 4.19c-.32-.33-1.94-.69-4-.69-3 0-7.09.75-9.8 3.46C1.87 11.55 2.9 20 3.69 20.81c.32.33 1.94.69 4.05.69 3 0 7.09-.75 9.8-3.46C22.13 13.45 21.1 5 20.31 4.19ZM7.74 19.5a12.52 12.52 0 0 1-2.53-.23A13.85 13.85 0 0 1 5 15.44l4 4c-.47.05-.92.06-1.26.06Zm8.39-2.87a9.8 9.8 0 0 1-4.66 2.44l-6-6a9.81 9.81 0 0 1 2.41-4.69A9.81 9.81 0 0 1 12.52 6l6.05 6a10 10 0 0 1-2.44 4.63Zm2.83-7-4-4c.52 0 1-.06 1.33-.06a12.52 12.52 0 0 1 2.53.23A14 14 0 0 1 19 9.59Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m9.18 13.49-1.85-.74A9.08 9.08 0 0 1 12 7.6l.84 1.81a7.13 7.13 0 0 0-3.66 4.08Z"
  }));
};
BallFootballCollege.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var BallFootballCollegeMultiple = function BallFootballCollegeMultiple(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M22.19 10.21c-.21-.3-1.43-.8-3.09-1.08-2.38-.4-5.67-.35-8.15 1.43-4.21 3-4.52 9.79-4 10.51.21.3 1.43.8 3.09 1.08 2.38.4 5.67.35 8.15-1.43 4.21-3 4.52-9.79 4-10.51ZM10.3 20.58c-.9-.15-1.57-.36-1.96-.51-.04-.64.06-1.78.37-3.03l2.62 3.68c-.41-.04-.77-.09-1.04-.13Zm6.97-1.15c-1.22.87-2.67 1.21-3.98 1.3l-3.95-5.54c.55-1.26 1.36-2.49 2.54-3.33 1.21-.86 2.66-1.2 3.97-1.3l3.95 5.55c-.55 1.26-1.36 2.48-2.53 3.32Zm3.15-5.16-2.63-3.7c.42.03.78.08 1.05.13.9.15 1.57.36 1.96.51.04.64-.06 1.78-.38 3.05Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m12.23 16.05-1.36-.83c1.09-1.79 2.54-2.95 4.33-3.44l.42 1.54c-1.4.38-2.51 1.28-3.39 2.73ZM5.2 14.91c.18-.51.39-1.02.63-1.52-.25-.03-.49-.06-.67-.09-.9-.15-1.57-.36-1.96-.51-.04-.64.06-1.78.37-3.03l2.4 3.36c.26-.51.55-1.01.88-1.49L4.2 7.91c.55-1.26 1.36-2.49 2.54-3.33 1.21-.86 2.66-1.2 3.97-1.3l2.85 4c1.12-.23 2.26-.31 3.35-.29.45-2.02.4-3.72.15-4.07-.21-.3-1.43-.8-3.09-1.08-2.38-.4-5.67-.35-8.15 1.43-4.22 3.01-4.53 9.8-4.01 10.52.21.3 1.43.8 3.09 1.08.1.02.2.03.3.04Zm8.5-11.49c.9.15 1.57.36 1.96.51.04.64-.06 1.78-.38 3.05l-2.63-3.7c.42.03.78.08 1.05.13Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m7.09 8.77-1.36-.83c1.09-1.79 2.54-2.95 4.33-3.44l.42 1.54c-1.4.38-2.51 1.28-3.39 2.73Z"
  }));
};
BallFootballCollegeMultiple.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var BallFootballNfl = function BallFootballNfl(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M20.31 3.69C20 3.36 18.37 3 16.26 3c-3 0-7.09.75-9.8 3.46-4.59 4.59-3.56 13.06-2.77 13.85.32.33 1.94.69 4.05.69 3 0 7.09-.75 9.8-3.46C22.13 13 21.1 4.48 20.31 3.69Zm-1.74 7.81a10 10 0 0 1-2.44 4.63C14 18.25 10.7 19 7.78 19c-.5 0-1 0-1.5-.08a4.3 4.3 0 0 1-1.07-.16 13.77 13.77 0 0 1 .09-5.5 10.71 10.71 0 0 1 1.84-4.52 7.48 7.48 0 0 1 .74-.86C10 5.76 13.14 5.08 16 5a13.39 13.39 0 0 1 1.42 0c.12 0 1.3.06 1.33.18A14 14 0 0 1 19 9.09Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m8.94 13.94-1.89-.65A9.08 9.08 0 0 1 13.34 7l.54 1.92a7.13 7.13 0 0 0-4.94 5.02Z"
  }));
};
BallFootballNfl.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var BallFootballNflMultiple = function BallFootballNflMultiple(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M22.19 10.21c-.21-.3-1.43-.8-3.09-1.08-2.38-.4-5.67-.35-8.15 1.43-4.21 3-4.52 9.79-4 10.51.21.3 1.43.8 3.09 1.08 2.38.4 5.67.35 8.15-1.43 4.21-3 4.52-9.79 4-10.51Zm-2.4 5.91c-.55 1.26-1.36 2.48-2.53 3.32-1.22.87-2.67 1.21-3.98 1.3l-1.95-.02c-.41-.04-.77-.09-1.04-.13-.9-.15-1.57-.36-1.96-.51-.04-.64.06-1.78.37-3.03l.62-1.84c.55-1.26 1.36-2.49 2.54-3.33 1.21-.86 2.66-1.2 3.97-1.3h1.94c.42.04.78.09 1.05.14.9.15 1.57.36 1.96.51.04.64-.06 1.78-.38 3.05l-.62 1.84Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m12.23 16.05-1.36-.83c1.09-1.79 2.54-2.95 4.33-3.44l.42 1.54c-1.4.38-2.51 1.28-3.39 2.73ZM16.9 6.99c.45-2.02.4-3.72.15-4.07-.21-.3-1.43-.8-3.09-1.08-2.38-.4-5.67-.35-8.15 1.43-4.21 3.01-4.52 9.8-4 10.52.21.3 1.43.8 3.09 1.08.1.02.2.03.3.04.18-.51.39-1.02.63-1.52-.25-.03-.49-.06-.67-.09-.9-.15-1.57-.36-1.96-.51-.04-.64.06-1.78.37-3.03l.62-1.84c.55-1.26 1.36-2.49 2.54-3.33 1.21-.86 2.66-1.2 3.97-1.3h1.94c.42.04.78.09 1.05.14.9.15 1.57.36 1.96.51.04.64-.06 1.78-.38 3.05h1.62Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m7.09 8.77-1.36-.83c1.09-1.79 2.54-2.95 4.33-3.44l.42 1.54c-1.4.38-2.51 1.28-3.39 2.73Z"
  }));
};
BallFootballNflMultiple.defaultProps = {
  className: "svg-fill",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var BallSoccer = function BallSoccer(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 3.3 1.35-1a8 8 0 0 1 4.38 3.34L18.34 9 17 9.49 13 6.7Zm-3.35-1 1.35 1v1.4L7 9.49 5.66 9l-.39-1.31a8.1 8.1 0 0 1 4.38-3.34ZM7.08 17.11l-1.14.1A7.94 7.94 0 0 1 4 12v-.35l1-.73 1.38.48 1.46 4.34Zm7.42 2.48a7.83 7.83 0 0 1-5 0l-.69-1.49.64-1.1h5.11l.64 1.11ZM14.27 15H9.73l-1.35-4L12 8.44 15.63 11Zm3.79 2.21-1.14-.1-.79-1.37 1.46-4.34 1.41-.47 1 .73V12a7.94 7.94 0 0 1-1.94 5.21Z"
  }));
};
BallSoccer.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var BallSoccerMultiple = function BallSoccerMultiple(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M14.64 1.95a7.49 7.49 0 0 0-6.1 3.15c.27-.02.55-.04.83-.04 1.09 0 2.14.19 3.11.53l-.24-.42.53-1.11c.59-.19 1.22-.31 1.88-.31.66 0 1.28.11 1.88.31l.52 1.12-.48.82h-3.08c.58.28 1.13.61 1.63 1h1.23l.63 1.88a9.25 9.25 0 0 1 1.36 2.56l.67.23.29 1.01c-.15.24-.33.46-.52.67.05.4.08.8.08 1.21 0 .38-.03.76-.07 1.13a7.482 7.482 0 0 0 3.35-6.24c0-4.14-3.36-7.5-7.5-7.5Zm5.23 8.31-1.03-.36-1.1-3.25.59-1.03.85-.07a5.957 5.957 0 0 1 1.46 3.91c0 .09 0 .17-.02.26l-.75.55v-.01Z"
  }), React__default.createElement("path", {
    d: "M9.36 7.05c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5ZM10 9.53l1.01-.71c1.36.42 2.53 1.32 3.28 2.51L14 12.34l-1.01.35L10 10.6V9.53Zm-2.01-.71L9 9.53v1.05l-2.99 2.09L5 12.32l-.29-1a6.101 6.101 0 0 1 3.28-2.51v.01Zm-2.31 9.57-.85.08a5.957 5.957 0 0 1-1.46-3.91c0-.09 0-.17.01-.26l.75-.55 1.04.36 1.1 3.26-.59 1.03v-.01Zm5.57 1.56a5.836 5.836 0 0 1-3.76 0l-.52-1.12.48-.83h3.83l.48.83-.52 1.11.01.01Zm-.17-2.94H7.67l-1.01-3.02 2.72-1.9 2.72 1.9-1.02 3.02Zm2.84 1.46-.85-.08-.59-1.03 1.1-3.26 1.04-.35.75.55c0 .08.02.17.02.26 0 1.49-.55 2.86-1.46 3.91h-.01Z"
  }));
};
BallSoccerMultiple.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Injury = function Injury(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m17.73 12 4-4a1 1 0 0 0 0-1.41l-4.36-4.3a1 1 0 0 0-1.41 0l-4 4-4-4A1 1 0 0 0 7.29 2a1 1 0 0 0-.7.29L2.25 6.63a1 1 0 0 0 0 1.37l4 4-4 4a1 1 0 0 0 0 1.41l4.34 4.34a1 1 0 0 0 1.41 0l4-4 4 4a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l4.34-4.34a1 1 0 0 0 0-1.41ZM12 9a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm-4.71 2L3.66 7.34l3.63-3.63 3.62 3.62ZM10 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm2 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm2-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm2.66 9.34L13 16.72l3.63-3.63 3.62 3.62Z"
  }));
};
Injury.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MissedPenalty = function MissedPenalty(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z",
    fill: "#ee855b"
  }));
};
MissedPenalty.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MultipleRedCard = function MultipleRedCard(props) {
  return React__default.createElement("svg", props, React__default.createElement("rect", {
    x: "9.5",
    y: "8",
    width: "9",
    height: "14",
    rx: "2",
    ry: "2",
    fill: "#d20011"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M7.5 8c0-1.1.9-2 2-2h5V4c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2V8Z",
    fill: "#d20011"
  }));
};
MultipleRedCard.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MultipleShotsOffTarget = function MultipleShotsOffTarget(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M9.5 9c3.03 0 5.5 2.47 5.5 5.5S12.53 20 9.5 20 4 17.53 4 14.5 6.47 9 9.5 9Zm0-2C5.36 7 2 10.36 2 14.5S5.36 22 9.5 22s7.5-3.36 7.5-7.5S13.64 7 9.5 7Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m7.737 11.319 4.95 4.95-1.415 1.414-4.95-4.95z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m12.681 12.737-4.95 4.95-1.414-1.415 4.95-4.95zM14.5 2a7.47 7.47 0 0 0-6.03 3.06C8.81 5.02 9.15 5 9.5 5c.56 0 1.11.06 1.64.15A5.46 5.46 0 0 1 14.5 4C17.53 4 20 6.47 20 9.5c0 1.26-.43 2.43-1.15 3.36.09.54.15 1.08.15 1.64 0 .35-.02.69-.06 1.03C20.79 14.16 22 11.97 22 9.5 22 5.36 18.64 2 14.5 2Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m16.88 8.53.8-.8-1.41-1.41-.8.8c.52.42.99.89 1.41 1.41Z"
  }));
};
MultipleShotsOffTarget.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MultipleShotsOnTarget = function MultipleShotsOnTarget(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M11.33 10.33c-.92 0-1.67.75-1.67 1.67s.75 1.67 1.67 1.67S13 12.92 13 12l2.8-1.64c.81-.47 2.25-.28 3.09.13L23 8.1l-2.63-1.31.14-3.03-4.12 2.39c-.06.93-.61 2.28-1.42 2.75l-2.82 1.64c-.24-.14-.52-.22-.82-.22Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M11.33 13.66c-.92 0-1.67-.75-1.67-1.67s.75-1.67 1.67-1.67 1.67.75 1.67 1.67l2.8 1.64c.81.47 2.25.28 3.09-.13L23 15.89l-2.63 1.31.14 3.03-4.12-2.39c-.06-.93-.61-2.28-1.42-2.75l-2.82-1.64c-.24.14-.52.22-.82.22Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M14.7 17.74c.28.49.36 1.28.12 1.81-.26.12-.54.23-.82.33-.28.09-.56.18-.85.24-.15.04-.3.07-.45.09-.18.03-.38.06-.57.08-.26.03-.53.04-.8.04-4.6 0-8.33-3.73-8.33-8.34s3.73-8.32 8.33-8.32c.27 0 .54.01.8.04.04 0 .08.01.12.01.2.02.41.05.6.09.06.01.11.02.16.03.2.04.38.09.57.14.19.05.39.11.58.19.19.07.38.15.57.23.03.01.06.02.09.04.24.53.16 1.33-.12 1.82a6.42 6.42 0 0 0-1.47-.64c-.18-.06-.37-.1-.55-.14-.18-.04-.36-.07-.54-.09-.11-.02-.22-.03-.33-.03-.15-.01-.31-.02-.47-.02-3.67 0-6.66 2.99-6.66 6.66s2.99 6.67 6.66 6.67c.16 0 .31-.01.47-.02.11 0 .22-.01.33-.03.18-.02.36-.05.54-.09.18-.04.37-.08.55-.14.05-.01.1-.03.15-.05.19-.06.36-.12.54-.2.18-.08.35-.16.52-.25.09-.05.17-.09.25-.14Z"
  }));
};
MultipleShotsOnTarget.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MultipleSubstitution = function MultipleSubstitution(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M-.08 0h24v24h-24V0Z",
    fill: "none"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M10.43 17.01V10h-2v7.01h-3l4 3.99 4-3.99h-3ZM5.43 3l-4 3.99h3V14h2V6.99h3L5.43 3ZM19.4 17.01V10h-2v7.01h-3l4 3.99 4-3.99h-3ZM14.4 3l-4 3.99h3V14h2V6.99h3L14.4 3Z"
  }));
};
MultipleSubstitution.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MultipleYellowCard = function MultipleYellowCard(props) {
  return React__default.createElement("svg", props, React__default.createElement("rect", {
    x: "9.5",
    y: "8",
    width: "9",
    height: "14",
    rx: "2",
    ry: "2",
    fill: "#fde551"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M7.5 8c0-1.1.9-2 2-2h5V4c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2V8Z",
    fill: "#fde551"
  }));
};
MultipleYellowCard.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var RedCard = function RedCard(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M7.56 2h8.89c.29 0 .58.06.85.19a2.35 2.35 0 0 1 1.2 1.35c.11.3.17.63.17.96v15c0 .33-.06.65-.17.96-.11.3-.28.58-.48.81a2.2 2.2 0 0 1-.72.54c-.27.13-.56.19-.85.19H7.56c-.59 0-1.15-.26-1.57-.73-.42-.47-.65-1.1-.65-1.77v-15c0-.33.06-.65.17-.96.11-.3.28-.58.48-.81.21-.23.45-.42.72-.54.27-.13.56-.19.85-.19Z",
    fill: "#d20011"
  }));
};
RedCard.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ShotsOffTarget = function ShotsOffTarget(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8Zm0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Z"
  }), React__default.createElement("path", {
    d: "m8.464 7.05 8.486 8.486-1.414 1.414L7.05 8.465z"
  }), React__default.createElement("path", {
    d: "M16.95 8.464 8.463 16.95 7.05 15.536l8.485-8.486z"
  }));
};
ShotsOffTarget.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ShotsOnTarget = function ShotsOnTarget(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M11.33 10.33c-.92 0-1.67.75-1.67 1.67s.75 1.67 1.67 1.67S13 12.92 13 12l2.8-1.64c.81-.47 2.25-.28 3.09.13L23 8.1l-2.63-1.31.14-3.03-4.12 2.39c-.06.93-.61 2.28-1.42 2.75l-2.82 1.64c-.24-.14-.52-.22-.82-.22Zm6.66 1.59v.07c0 3.68-2.99 6.67-6.66 6.67s-6.67-2.99-6.67-6.67 2.99-6.67 6.67-6.67c1.23 0 2.38.34 3.37.92.28-.49.36-1.29.12-1.82a8.292 8.292 0 0 0-3.49-.77C6.73 3.67 3 7.4 3 12s3.73 8.33 8.33 8.33c4.36 0 7.93-3.35 8.3-7.62-.25-.4-.89-.88-1.63-.79Z"
  }));
};
ShotsOnTarget.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var StartingEleven = function StartingEleven(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Z"
  }), React__default.createElement("text", {
    className: "svg-fill",
    transform: "translate(6.02 -3.14)",
    style: {
      fontSize: "12px",
      fontFamily: "Inter-Bold,Inter",
      fontWeight: "700"
    }
  }, "XI"), React__default.createElement("path", {
    className: "svg-fill",
    d: "M15 8h2v8h-2zM14 16h-2L7 8h2l5 8z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M7 16h2l5-8h-2l-5 8z"
  }));
};
StartingEleven.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Substitution = function Substitution(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M0 0h24v24H0V0Z",
    fill: "none"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3ZM9 3 5 6.99h3V14h2V6.99h3L9 3Z"
  }));
};
Substitution.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var YellowCard = function YellowCard(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M7.55 2h8.89c.29 0 .58.06.85.19a2.35 2.35 0 0 1 1.2 1.35c.11.3.17.63.17.96v15c0 .33-.06.65-.17.96-.11.3-.28.58-.48.81a2.2 2.2 0 0 1-.72.54c-.27.13-.56.19-.85.19H7.55c-.59 0-1.15-.26-1.57-.73-.42-.47-.65-1.1-.65-1.77v-15c0-.33.06-.65.17-.96.11-.3.28-.58.48-.81.21-.23.45-.42.72-.54.27-.13.56-.19.85-.19Z",
    fill: "#fde551"
  }));
};
YellowCard.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Clone = function Clone(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M15 2H4v14h2V4h9V2Zm5 4H8v16h12V6Zm-2 14h-8V8h8v12Z"
  }));
};
Clone.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Delete = function Delete(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "m6 7 1 14h10l1-14Zm2.23 2h7.54L15 19H9Zm7.27-5-1-1h-5l-1 1H5v2h14V4Z"
  }));
};
Delete.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Download = function Download(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M5 20h14v-2H5ZM19 9h-4V3H9v6H5l7 7Z"
  }));
};
Download.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Edit = function Edit(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25Zm15.88-8.38 2.53-2.54-3.75-3.75-2.53 2.54 3.75 3.75Z"
  }));
};
Edit.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Folder = function Folder(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M2 20V4h8l2 2h10v2H11.175l-2-2H4v12l2.4-8h17.1l-3 10H2Zm4.1-2H19l1.8-6H7.9l-1.8 6Z"
  }));
};
Folder.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Paste = function Paste(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M14.82 4c-.4-1.17-1.51-2-2.82-2s-2.42.83-2.82 2H5.04v18h14V4h-4.22ZM13 5v1h-2V5c0-.55.45-1 1-1s1 .45 1 1Zm4.04 15h-10V6H9v2h6V6h2.04v14Z"
  }));
};
Paste.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Print = function Print(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M16 8V5H8v3H6V3h12v5h-2Zm0 11v-4H8v4h8Zm2 2H6v-4H2V8h20v9h-4v4Zm2-6v-5H4v5h2v-2h12v2h2ZM4 10h16H4Z"
  }));
};
Print.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Save = function Save(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M3 20V2h14l4 4v14H3Zm2-2h14V6.85L16.15 4H5v14Zm7-2c.833 0 1.542-.292 2.125-.875A2.893 2.893 0 0 0 15 13c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 10c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 13c0 .833.292 1.542.875 2.125A2.893 2.893 0 0 0 12 16ZM7 8h8V6H7v2Z"
  }));
};
Save.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var SaveAs = function SaveAs(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M3 21V3h14l4 4v5.4l-2 2V7.825L16.175 5H5v14h9.4l-2 2H3Zm9-4c.833 0 1.542-.292 2.125-.875A2.893 2.893 0 0 0 15 14c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 11c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 14c0 .833.292 1.542.875 2.125A2.893 2.893 0 0 0 12 17ZM7 9h8V7H7v2Zm8 14v-1.775l5-4.975 1.75 1.775L16.775 23H15Zm7.4-5.65-1.775-1.75 1.225-1.225 1.75 1.775-1.2 1.2ZM5 19V5v14Z"
  }));
};
SaveAs.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Upload = function Upload(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M13 4H6.01v16H18V9l-5-5Zm3 14H8V6h5v3h3v9Z"
  }), React__default.createElement("path", {
    d: "m12 10 3 3h-2v4h-2v-4H9l3-3Z"
  }));
};
Upload.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var PowerProductivity = function PowerProductivity(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M11.5 19h-1l1-6h-3s2.07-4.59 4-8h1l-1 6h3l-4 8Z",
    fill: "#70C6CA"
  }));
};
PowerProductivity.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Priorities = function Priorities(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M14 4h-4l1 12h2l1-12Zm-1 16h-2v-2h2v2Z"
  }));
};
Priorities.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var QAndA = function QAndA(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M19.96 9h-2v7h-10v2h9l3 3V9Zm-4-4h-12v12l3-3h9"
  }));
};
QAndA.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Stopwatch = function Stopwatch(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M15 1.5H9v2h6v-2Zm-4 13h2v-6h-2v6Zm8.03-6.61 1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0 0 12 4.5c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 0 0 7.03-14.61ZM12 20.5c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7Z"
  }));
};
Stopwatch.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Api = function Api(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M7.39 8H5.01L2 16.72h1.97l.65-1.99h3.15l.65 1.99h1.98L7.39 8Zm-2.3 5.29 1.08-3.3h.06l1.07 3.3H5.09ZM17.65 9.42c-.25-.45-.6-.79-1.07-1.05-.47-.25-1.03-.37-1.69-.37h-3.44v8.72h1.84v-2.83h1.55c.67 0 1.24-.12 1.72-.37.47-.24.83-.59 1.08-1.03.25-.44.38-.96.38-1.54 0-.58-.13-1.09-.37-1.53Zm-1.71 2.29c-.11.22-.29.4-.52.52-.23.12-.52.19-.88.19h-1.25V9.51h1.24c.36 0 .66.06.89.18.23.12.41.29.52.5.12.22.18.47.18.76 0 .29-.06.54-.18.76ZM21.06 8v8.73h-1.84V8h1.84Z"
  }));
};
Api.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Changelog = function Changelog(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M11 7h6v2h-6V7Zm0 4h6v2h-6v-2Zm0 4h6v2h-6v-2ZM7 7h2v2H7V7Zm0 4h2v2H7v-2Zm0 4h2v2H7v-2ZM3 3v18h18V3H3Zm16 16H5V5h14v14Z"
  }));
};
Changelog.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Faq = function Faq(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M6 2v16h15V2H6Zm13 14H8V4h11v12Z"
  }), React__default.createElement("path", {
    d: "M4 6H2v16h12v-2H4V6ZM14.22 13h-2v2h2v-2ZM16.77 8.79c-.13.3-.32.56-.55.79-.24.23-.52.44-.84.62-.28.16-.49.32-.67.48-.17.17-.31.37-.39.59-.08.23-.13.82-.13.82h-1.96c0-.58.06-1.04.17-1.38.1-.35.26-.62.46-.83.2-.22.45-.41.73-.58.21-.13.4-.27.58-.41.17-.14.3-.3.4-.48.1-.17.15-.37.15-.58 0-.23-.06-.43-.17-.61-.11-.17-.27-.3-.45-.39a1.489 1.489 0 0 0-1.26 0c-.2.09-.37.23-.49.42-.13.18-.19.42-.21.68h-2.1c.02-.66.18-1.21.49-1.64a2.9 2.9 0 0 1 1.24-.97 4.31 4.31 0 0 1 1.71-.33c.68 0 1.29.11 1.82.33.53.22.93.53 1.23.94.3.42.45.91.45 1.49 0 .38-.07.73-.2 1.03l-.01.01Z"
  }));
};
Faq.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Goalkeeper = function Goalkeeper(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M14.27 6A2 2 0 1 0 17 5.27a2 2 0 0 0-2.73.73Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m15.84 10.41-2.6-1.5a5 5 0 0 1-1.82-6.82l-1.73-1a7 7 0 0 0 1 8.31l-5.18 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1L15.49 13a5 5 0 0 1 .31 5.46l1.73 1a7.11 7.11 0 0 0-1.69-9.05Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M12.75 3.8a1.5 1.5 0 1 0-.55-2 1.5 1.5 0 0 0 .55 2Z"
  }));
};
Goalkeeper.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var IqScout = function IqScout(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M18.43 18a3.86 3.86 0 0 0 .57-2 4 4 0 1 0-4 4 4 4 0 0 0 2-.57L19.59 22 21 20.59ZM15 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2ZM12.75 5.72a1.86 1.86 0 1 0-1.86-1.86 1.87 1.87 0 0 0 1.86 1.86Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M9 16.5a6.5 6.5 0 0 1 3.7-5.86l.05-.27.16.17a6.23 6.23 0 0 1 2.28-.54 4.26 4.26 0 0 1-1.32-1.4l-.93-1.48a1.92 1.92 0 0 0-1.58-.93c-.28 0-.47.09-.75.09L5.77 8.33v4.37h1.86V9.53l1.68-.65-1.49 7.54-4.56-.93-.37 1.86 6.48 1.29A6.33 6.33 0 0 1 9 16.5Z"
  }));
};
IqScout.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var IqTactics = function IqTactics(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M5.095 2.476 6.99 1.84 8.9 7.528l-1.897.636z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m3.835 5.009 5.688-1.91.637 1.896-5.688 1.91zM17 13l-3 2.29L15.15 19h3.7L20 15.29 17 13zM18.48 11A3.52 3.52 0 1 1 22 7.47 3.5 3.5 0 0 1 18.48 11Zm0-5A1.52 1.52 0 1 0 20 7.47 1.5 1.5 0 0 0 18.48 6ZM9.5 23a3.5 3.5 0 1 1 3.5-3.5A3.5 3.5 0 0 1 9.5 23Zm0-5a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 9.5 18Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "m11 17.17-2-.34c.89-5.16 2.73-7.52 7.57-9.74l.84 1.82c-4.21 1.93-5.65 3.78-6.41 8.26ZM7.4 18.8C3.09 15.57 1.79 11 4.17 7.45l1.66 1.1c-1.77 2.66-.69 6.06 2.77 8.65Z"
  }));
};
IqTactics.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var League = function League(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 16C7.14 16 7.05 9.25 7 6V3h10v1c0 5.35 0 12-5 12ZM9 5v1c.07 5.69.94 8 3 8 2.6 0 3-4 3-9Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M8 13c-4.43 0-5-3.74-5-7V5h5v2H5c.19 3.67 1.51 4 3 4ZM16 13v-2c1.46 0 2.78-.33 3-4h-3V5h5v1c0 3.26-.56 7-5 7ZM7 19h10v2H7z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M11 15h2v5h-2z"
  }));
};
League.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MatchFootball = function MatchFootball(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M15 7H9V1h2v4h2V1h2v6zM11 7h2v2h-2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M22.28 22H1.72l3.5-14h13.56Zm-18-2h15.44l-2.5-10H6.78Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M5.5 12h13.42v2H5.5zM4 16h16v2H4z"
  }));
};
MatchFootball.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MatchSoccer = function MatchSoccer(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M22 20H2V4h20ZM4 18h16V6H4Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 15a3 3 0 1 1 3-3 3 3 0 0 1-3 3Zm0-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M11 5h2v5h-2zM18 9h2v6h-2zM4 9h2v6H4zM11 14h2v5h-2z"
  }));
};
MatchSoccer.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MatchSportsAgnostic = function MatchSportsAgnostic(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M5 5h2v14H5V5ZM9 5h2v2H9V5ZM13 5h2v2h-2V5ZM17 5h2v2h-2V5ZM17 9h-2V7h2v2ZM13 9h-2V7h2v2ZM9 9H7V7h2v2ZM9 9h2v2H9V9ZM13 9h2v2h-2V9ZM17 9h2v2h-2V9ZM17 13h-2v-2h2v2ZM13 13h-2v-2h2v2ZM9 13H7v-2h2v2ZM9 13h2v2H9v-2ZM13 13h2v2h-2v-2ZM17 13h2v2h-2v-2Z"
  }));
};
MatchSportsAgnostic.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlayerFootball = function PlayerFootball(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M13.75 14.97c-.3-.61-.51-1.28-.63-1.97H21v-1c0-4.96-4.04-9-9-9s-9 4.04-9 9c0 3.51 3.03 8.33 3.16 8.54l.29.46H13v-3.52c1.67 2.13 4.21 3.52 7 3.52h1v-6.03h-7.25ZM11 19H7.57C6.85 17.77 5 14.38 5 12c0-3.86 3.14-7 7-7 3.52 0 6.44 2.61 6.93 6H11v8Zm8-.08a6.965 6.965 0 0 1-3.8-1.95h3.81v1.95Z"
  }));
};
PlayerFootball.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PlayerSoccer = function PlayerSoccer(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M13.56 6.32a1.66 1.66 0 1 0-1.62-1.66 1.64 1.64 0 0 0 1.62 1.66Zm-2.91 11.53.81-3.65 1.7 1.66v5h1.61v-6.24L13.07 13l.49-2.49A5.85 5.85 0 0 0 18 12.54v-1.66a4 4 0 0 1-3.47-2l-.81-1.33a1.67 1.67 0 0 0-1.37-.83c-.24 0-.41.09-.65.09L7.5 8.64v3.9h1.62V9.72l1.45-.58-1.29 6.72-4-.83L5 16.69Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M13.56 6.32a1.66 1.66 0 1 0-1.62-1.66 1.64 1.64 0 0 0 1.62 1.66Zm-2.91 11.53.81-3.65 1.7 1.66v5h1.61v-6.24L13.07 13l.49-2.49A5.85 5.85 0 0 0 18 12.54v-1.66a4 4 0 0 1-3.47-2l-.81-1.33a1.67 1.67 0 0 0-1.37-.83c-.24 0-.41.09-.65.09L7.5 8.64v3.9h1.62V9.72l1.45-.58-1.29 6.72-4-.83L5 16.69ZM16.75 20.8a1.5 1.5 0 1 0-.55-2.05 1.5 1.5 0 0 0 .55 2.05Z"
  }));
};
PlayerSoccer.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Support = function Support(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M11 18h2v-2h-2Zm1-16a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Zm0-14a4 4 0 0 0-4 4h2a2 2 0 0 1 4 0c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4Z"
  }));
};
Support.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var TeamFootball = function TeamFootball(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2.11 3 5.78v5.65a11.31 11.31 0 0 0 6.47 9.9 8.08 8.08 0 0 0 .85.37h.08l.22.07.47.16c.22.07.44.13.67.18l.22.05.22-.05c.23-.05.46-.11.68-.18l.47-.16.22-.07h.08a8.08 8.08 0 0 0 .85-.37 11.31 11.31 0 0 0 6.5-9.9V5.78ZM10.51 19.6A9.25 9.25 0 0 1 5 11.36V7.13l7-2.86 7 2.86v4.23a9.25 9.25 0 0 1-5.5 8.24c-.32.15-1.16.48-1.5.59 0 0-1.17-.44-1.49-.59Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M15.7 7.89a3.66 3.66 0 0 0-1.8-.31 6.24 6.24 0 0 0-4.36 1.54 6.54 6.54 0 0 0-1.23 6.16 3.6 3.6 0 0 0 1.8.31 6.28 6.28 0 0 0 4.36-1.54 6.54 6.54 0 0 0 1.23-6.16Zm-2.89 1.76h.71s.37 0 .38.06a3.91 3.91 0 0 1-.06 1.7 2.75 2.75 0 0 1-.69 1.37 3.39 3.39 0 0 1-2.37.81 3.64 3.64 0 0 1-.71-.06s-.05-.33-.05-.36a3 3 0 0 1 0-.52 3.22 3.22 0 0 1 .81-2.2 2.84 2.84 0 0 1 1.46-.72Z"
  }));
};
TeamFootball.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var TeamSoccer = function TeamSoccer(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 7a5 5 0 1 0 5 5 5 5 0 0 0-5-5Zm.46 1.94.62-.44a3.75 3.75 0 0 1 2 1.53l-.18.62-.62.21-1.82-1.28Zm-1.54-.44.62.44v.64l-1.83 1.28-.62-.21-.18-.65a3.75 3.75 0 0 1 2.01-1.5Zm-1.18 5.85-.52.05a3.69 3.69 0 0 1-.89-2.4v-.16l.46-.34.63.22.67 2Zm3.41 1.14a3.58 3.58 0 0 1-2.3 0l-.31-.69.29-.5h2.34l.3.51ZM13 13.24h-2l-.58-1.72L12 10.43l1.56 1.09Zm1.81 1.16-.52-.05-.37-.63.67-2 .64-.21.46.33V12a3.69 3.69 0 0 1-.91 2.4Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2 3 5.63v5.65a11.3 11.3 0 0 0 6.46 9.9 9.1 9.1 0 0 0 .85.37h.08l.23.07.46.16c.23.07.44.13.67.18L12 22l.22-.05a6.75 6.75 0 0 0 .68-.18l.47-.16.22-.07h.08a9.28 9.28 0 0 0 .86-.37A11.32 11.32 0 0 0 21 11.28V5.63Zm-1.49 17.45A9.23 9.23 0 0 1 5 11.21V7l7-2.86L19 7v4.23a9.25 9.25 0 0 1-5.49 8.24c-.32.15-1.15.48-1.49.59-.02-.06-1.19-.46-1.51-.61Z"
  }));
};
TeamSoccer.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ThreeSixty = function ThreeSixty(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M7.53 13.68c0 1.83-1.41 3.16-3.31 3.16-1.9 0-3.16-1.28-3.23-3.12H3c.04.76.52 1.24 1.22 1.24.76 0 1.29-.56 1.29-1.36s-.57-1.3-1.43-1.3H2.72v-.38l1.7-2.81H1.23V7.32h5.95v.38l-1.93 3.07c1.38.31 2.28 1.42 2.28 2.89M13.09 13.48c0-.9-.63-1.51-1.51-1.51s-1.51.61-1.51 1.51c-.03.8.6 1.47 1.4 1.5h.11c.88 0 1.51-.61 1.51-1.5Zm2.01 0c0 1.97-1.46 3.36-3.52 3.36s-3.54-1.38-3.54-3.36c0-.83.23-1.69.97-2.96l1.86-3.2h2.2c-.78 1.35-1.34 2.29-1.91 3.28.28-.08.57-.13.87-.13 1.77-.01 3.07 1.21 3.07 3M20.98 12.01c0-1.92-.63-2.98-1.76-2.98s-1.76 1.05-1.76 2.97c0 1.92.62 2.97 1.76 2.97 1.14 0 1.76-1.04 1.76-2.96ZM15.43 12c0-2.99 1.45-4.84 3.79-4.84S23 9.01 23 12c0 2.99-1.46 4.84-3.78 4.84s-3.79-1.87-3.79-4.84Z"
  }));
};
ThreeSixty.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var PitchAllLandscape = function PitchAllLandscape(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M2 4h20v16H2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M22 8.34V4H2v16h20V8.34Zm-1 6.32h-2.22V9.34H21v5.32Zm-18 1h3.22V8.34H3V5h8.5v4.09c-1.39.24-2.46 1.45-2.46 2.91s1.06 2.67 2.46 2.91V19H3v-3.34Zm0-1V9.34h2.22v5.32H3Zm9.5-4.63c.88.22 1.54 1.02 1.54 1.97s-.66 1.75-1.54 1.97v-3.95Zm-1 3.95c-.88-.22-1.54-1.02-1.54-1.97s.66-1.75 1.54-1.97v3.95Zm9.5 5.03h-8.5v-4.09c1.39-.24 2.46-1.45 2.46-2.91S13.9 9.34 12.5 9.1V5H21v3.34h-3.22v7.32H21V19Z"
  }));
};
PitchAllLandscape.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchAllPortrait = function PitchAllPortrait(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M4 22V2h16v20z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M8.34 2H4v20h16V2H8.34Zm6.32 1v2.22H9.34V3h5.32Zm1 18v-3.22H8.34V21H5v-8.5h4.09c.24 1.39 1.45 2.46 2.91 2.46s2.67-1.06 2.91-2.46H19V21h-3.34Zm-1 0H9.34v-2.22h5.32V21Zm-4.63-9.5c.22-.88 1.02-1.54 1.97-1.54s1.75.66 1.97 1.54h-3.95Zm3.95 1c-.22.88-1.02 1.54-1.97 1.54s-1.75-.66-1.97-1.54h3.95ZM19 3v8.5h-4.09c-.24-1.39-1.45-2.46-2.91-2.46S9.33 10.1 9.09 11.5H5V3h3.34v3.22h7.32V3H19Z"
  }));
};
PitchAllPortrait.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchAttackingHalfLandscape = function PitchAttackingHalfLandscape(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M2 4h20v16H2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M22 8.34V4H2v16h20V8.34Zm-1 6.32h-2.22V9.34H21v5.32Zm-8.5-4.63c.88.22 1.54 1.02 1.54 1.97s-.66 1.75-1.54 1.97v-3.95ZM21 19h-8.5v-4.09c1.39-.24 2.46-1.45 2.46-2.91S13.9 9.33 12.5 9.09V5H21v3.34h-3.22v7.32H21V19Z"
  }));
};
PitchAttackingHalfLandscape.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchAttackingHalfPortrait = function PitchAttackingHalfPortrait(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M20 2v20H4V2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M20 12.5V2H4v20h16v-9.5Zm-9.97-1c.22-.88 1.02-1.54 1.97-1.54s1.75.66 1.97 1.54h-3.95ZM14.66 3v2.22H9.34V3h5.32ZM8.34 3v3.22h7.32V3H19v8.5h-4.09c-.24-1.39-1.45-2.46-2.91-2.46S9.33 10.1 9.09 11.5H5V3h3.34Z"
  }));
};
PitchAttackingHalfPortrait.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchAttackingThirdLandscape = function PitchAttackingThirdLandscape(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M2 4h20v16H2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M15.33 4H2v16h20V4h-6.67ZM21 14.66h-2.22V9.34H21v5.32Zm-3.22-6.32v7.32H21V19h-5.67V5H21v3.34h-3.22Z"
  }));
};
PitchAttackingThirdLandscape.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchAttackingThirdPortrait = function PitchAttackingThirdPortrait(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M20 2v20H4V2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M20 12.5V2H4v20h16v-9.5ZM14.66 3v2.22H9.34V3h5.32ZM5 3h3.34v3.22h7.32V3H19v5.67H5V3Z"
  }));
};
PitchAttackingThirdPortrait.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchDefensiveHalfLandscape = function PitchDefensiveHalfLandscape(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M2 4h20v16H2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M12.5 4H2v16h20V4h-9.5Zm-1 9.97c-.88-.22-1.54-1.02-1.54-1.97s.66-1.75 1.54-1.97v3.95ZM3 9.34h2.22v5.32H3V9.34Zm0 6.32h3.22V8.34H3V5h8.5v4.09c-1.39.24-2.46 1.45-2.46 2.91s1.06 2.67 2.46 2.91V19H3v-3.34Z"
  }));
};
PitchDefensiveHalfLandscape.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchDefensiveHalfPortrait = function PitchDefensiveHalfPortrait(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M20 2v20H4V2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M15.66 22H20V2H4v20h11.66Zm-6.32-1v-2.22h5.32V21H9.34Zm4.63-8.5c-.22.88-1.02 1.54-1.97 1.54s-1.75-.66-1.97-1.54h3.95ZM5 21v-8.5h4.09c.24 1.39 1.45 2.46 2.91 2.46s2.67-1.06 2.91-2.46H19V21h-3.34v-3.22H8.34V21H5Z"
  }));
};
PitchDefensiveHalfPortrait.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchDefensiveThirdLandscape = function PitchDefensiveThirdLandscape(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fill: "#0000",
    d: "M2 4h20v16H2z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M12.5 4H2v16h20V4h-9.5ZM3 9.34h2.22v5.32H3V9.34ZM3 19v-3.34h3.22V8.34H3V5h5.67v14H3Z"
  }));
};
PitchDefensiveThirdLandscape.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PitchDefensiveThirdPortrait = function PitchDefensiveThirdPortrait(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M20 15.33V2H4v20h16v-6.67ZM9.34 21v-2.22h5.32V21H9.34Zm6.32-3.22H8.34V21H5v-5.67h14V21h-3.34v-3.22Z"
  }));
};
PitchDefensiveThirdPortrait.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Comment = function Comment(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M5 6h14v14l-3-3H5"
  }));
};
Comment.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Email = function Email(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12.19 20c-1.29 0-2.45-.18-3.46-.53-1.01-.35-1.86-.86-2.56-1.54s-1.23-1.5-1.59-2.47c-.37-.97-.55-2.08-.55-3.32 0-1.24.18-2.34.55-3.34.37-1 .9-1.85 1.61-2.57.71-.72 1.57-1.27 2.59-1.65C9.8 4.2 10.96 4 12.27 4c1.21 0 2.29.18 3.24.53.95.35 1.76.85 2.42 1.51.66.65 1.17 1.42 1.51 2.32.35.89.52 1.88.51 2.97 0 .75-.06 1.43-.2 2.06-.14.63-.34 1.17-.63 1.63-.29.46-.66.83-1.12 1.1-.46.27-1.02.42-1.68.46-.47.04-.85 0-1.14-.1-.29-.11-.51-.26-.67-.47-.15-.21-.25-.45-.3-.73h-.07c-.1.24-.29.46-.57.66-.28.2-.63.35-1.04.46-.41.11-.84.15-1.3.12-.48-.03-.93-.14-1.36-.33a3.34 3.34 0 0 1-1.14-.85c-.33-.37-.59-.83-.78-1.37-.19-.54-.28-1.17-.29-1.89 0-.71.1-1.32.3-1.84.2-.52.46-.96.79-1.32.33-.36.69-.64 1.09-.84.4-.2.81-.33 1.21-.39.46-.07.89-.07 1.3 0 .41.07.76.18 1.04.33.28.15.46.32.53.5h.09v-.68h1.91v5.94c0 .28.07.5.19.65.12.15.29.23.49.23.28 0 .51-.12.7-.37.19-.25.33-.63.43-1.14.09-.51.14-1.16.14-1.95s-.1-1.43-.3-2.01c-.2-.58-.48-1.07-.84-1.48-.36-.41-.78-.74-1.25-.99-.48-.26-.99-.44-1.54-.56a8 8 0 0 0-1.71-.18c-1.01 0-1.89.15-2.65.46-.76.31-1.38.74-1.89 1.29-.5.55-.88 1.2-1.13 1.94-.25.74-.38 1.55-.38 2.42 0 .96.14 1.81.4 2.55.27.74.66 1.36 1.18 1.86.52.5 1.16.89 1.92 1.15.76.26 1.64.39 2.63.39.47 0 .92-.03 1.37-.1.45-.07.85-.15 1.21-.24s.65-.19.87-.28l.6 1.76c-.26.15-.6.28-1.04.41-.44.13-.93.23-1.47.31-.55.08-1.11.12-1.68.12l.02-.02Zm-.28-5.5c.5 0 .89-.09 1.18-.29.29-.2.51-.47.63-.85.13-.38.19-.84.18-1.39 0-.49-.07-.9-.19-1.24-.12-.34-.32-.6-.62-.77-.29-.18-.69-.26-1.21-.26-.45 0-.83.09-1.15.29-.31.19-.55.46-.72.8-.16.34-.25.74-.25 1.21 0 .43.07.84.21 1.22.14.38.35.69.66.93.31.24.73.36 1.26.36l.02-.01Z"
  }));
};
Email.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Forward = function Forward(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M14 8.5v-4l7 7-7 7v-4.1c-5 0-8.5 1.6-11 5.1 1-5 4-10 11-11Z"
  }));
};
Forward.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Link = function Link(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5Zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2Zm-3-4h8v2H8v-2Z"
  }));
};
Link.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Share = function Share(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M18 16.08c-.7 0-1.33.26-1.83.67l-7.24-4.18c.04-.19.07-.38.07-.57s-.03-.39-.07-.57l7.16-4.13c.52.43 1.18.71 1.91.71 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .2.03.39.07.57L7.91 9.71C7.39 9.28 6.73 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.73 0 1.39-.27 1.91-.71l7.24 4.18c-.03.17-.07.35-.07.53 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92ZM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1ZM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z"
  }));
};
Share.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Analysis = function Analysis(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M9.36 6.08 8.34 3.86 7.32 6.08 5 6.42l1.69 1.71-.41 2.42 2.07-1.16 2.06 1.16L10 8.13l1.69-1.71-2.32-.34h-.01ZM17.05 11.09l-1.72-1.72L20.55 9l-.37 5.23-1.72-1.72-4.98 4.98-2.83-2.83-4.24 4.24L5 17.49l5.65-5.66 2.83 2.83 3.57-3.57Z"
  }));
};
Analysis.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Assign = function Assign(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M10.04 15h-4v2h4v-2ZM10.04 11h-4v2h4v-2ZM10.04 7h-4v2h4V7ZM14.89 11.63l-2.85-2.8 1.41-1.42 1.42 1.42L17.69 6l1.42 1.41-4.22 4.22ZM14.89 17l-2.85-2.8 1.41-1.42 1.42 1.42 2.82-2.83 1.42 1.41L14.89 17Z"
  }));
};
Assign.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MorningShift = function MorningShift(props) {
  return React__default.createElement("svg", props, React__default.createElement("g", {
    fill: "#FF9213"
  }, React__default.createElement("path", {
    d: "M12 7.91c-2.26 0-4.09 1.83-4.09 4.09s1.83 4.09 4.09 4.09 4.09-1.83 4.09-4.09S14.26 7.91 12 7.91ZM13 2h-2v4h2V2ZM13 18h-2v4h2v-4ZM22 13v-2h-4v2h4ZM6 13v-2H2v2h4ZM18.362 19.781l1.414-1.414-2.828-2.828-1.414 1.414 2.828 2.828ZM7.05 8.461l1.415-1.414L5.637 4.22 4.222 5.633 7.051 8.46ZM4.223 18.366l1.414 1.415 2.829-2.829-1.414-1.414-2.829 2.828ZM15.534 7.047l1.414 1.414 2.829-2.829-1.414-1.414-2.829 2.829Z"
  })));
};
MorningShift.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var NightShift = function NightShift(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M13.04 4c-5 0-8 4-8 8 0 4.42 3.6 8 8.04 8 2.98 0 5.57-1.62 6.96-4.02C13.05 16 10.05 9 13.05 4h-.01Z",
    fill: "#4A9DF2"
  }));
};
NightShift.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var OvernightShift1 = function OvernightShift1(props) {
  return React__default.createElement("svg", props, React__default.createElement("g", {
    fill: "#A9D6F9"
  }, React__default.createElement("path", {
    d: "M12.11 4c-5-.03-8.02 3.96-8.04 7.95-.02 4.42 3.56 8.02 7.99 8.05 2.98.02 5.58-1.58 6.98-3.98C12.05 16 9.08 8.98 12.11 4Z"
  }), React__default.createElement("path", {
    d: "m16.44 7.34-.56 2.25-.56-2.25-2.25-.56 2.25-.56.56-2.25.56 2.25 2.25.56-2.25.56Z"
  })));
};
OvernightShift1.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var OvernightShift2 = function OvernightShift2(props) {
  return React__default.createElement("svg", props, React__default.createElement("g", {
    fill: "#2965A3"
  }, React__default.createElement("path", {
    d: "M20.03 15.98A8.031 8.031 0 0 1 13.07 20c-.4 0-.8-.03-1.18-.08.09-.29.14-.6.14-.92 0-1.01-.5-1.91-1.27-2.45A4.003 4.003 0 0 0 7.03 14c-.58 0-1.14.13-1.64.36-.24-.75-.36-1.54-.36-2.36 0-4 3-8 8-8-3 5 0 12 7 11.98Z"
  }), React__default.createElement("path", {
    d: "M9.04 18c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2h2c.55 0 1-.45 1-1s-.45-1-1-1Z"
  })));
};
OvernightShift2.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var QualityIssue = function QualityIssue(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m10 17.72-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L10 8.42l1.71 4.04 4.38.38-3.32 2.88 1 4.28L10 17.72ZM19 4h-2v8h2V4Zm0 12h-2v-2h2v2Z"
  }));
};
QualityIssue.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var QualityScore = function QualityScore(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m12 17.77 6.18 3.73-1.64-7.03L22 9.74l-7.19-.61L12 2.5 9.19 9.13 2 9.74l5.46 4.73-1.64 7.03L12 17.77Z"
  }));
};
QualityScore.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Reassign = function Reassign(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M19.04 4h-14v18h14V4Zm-2 16h-10V6h10v14Z"
  }), React__default.createElement("path", {
    d: "m9.04 13 3-3v2h3v2h-3v2l-3-3ZM14 2l2 2H8l2-2h4Z"
  }));
};
Reassign.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Filter = function Filter(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M3 7h18v2H3zM6 11h12v2H6zM9 15h6v2H9z"
  }));
};
Filter.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var SortAscending = function SortAscending(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    opacity: ".12",
    d: "m17 14-5 5-5-5h10Z"
  }), React__default.createElement("path", {
    d: "m7 10 5-5 5 5H7Z"
  }));
};
SortAscending.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var SortDescending = function SortDescending(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    opacity: ".12",
    d: "m7 10 5-5 5 5H7Z"
  }), React__default.createElement("path", {
    d: "m17 14-5 5-5-5h10Z"
  }));
};
SortDescending.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var SortNone = function SortNone(props) {
  return React__default.createElement("svg", props, React__default.createElement("g", {
    clipPath: "url(#a)"
  }, React__default.createElement("path", {
    opacity: ".12",
    d: "m17 14-5 5-5-5h10ZM7 10l5-5 5 5H7Z"
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "a"
  }, React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};
SortNone.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Tune = function Tune(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M13 9V7h3V3h2v4h3v2h-8Zm3 12V11h2v10h-2ZM6 21v-4H3v-2h8v2H8v4H6Zm0-8V3h2v10H6Z"
  }));
};
Tune.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var BlockStop = function BlockStop(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M17 17H7V7h10v10ZM5 5v14h14V5H5Zm4.88 10.54-1.41-1.41 2.12-2.12-2.12-2.12 1.41-1.41L12 10.6l2.12-2.12 1.41 1.41-2.12 2.12 2.12 2.12-1.41 1.41L12 13.42l-2.12 2.12Z"
  }));
};
BlockStop.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Completed = function Completed(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M13.04 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6Zm3.67-9.54-5.27 5.27-2.07-2.06-1.13 1.13 3.2 3.2 6.4-6.4-1.13-1.14Z"
  }));
};
Completed.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var InProgress = function InProgress(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12.04 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6Z"
  }), React__default.createElement("path", {
    d: "M9.04 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12.04 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15.04 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};
InProgress.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var NotStarted = function NotStarted(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M13.04 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6Z"
  }), React__default.createElement("path", {
    d: "M11.67 9h-2v6h2V9ZM13.67 15l4-3-4-3v6Z"
  }));
};
NotStarted.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Success = function Success(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm-1.6 12-3.2-3.2 1.13-1.13 2.07 2.06 5.27-5.27L16.8 9.6 10.4 16Z"
  }));
};
Success.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var AddTrackAbove = function AddTrackAbove(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M22 13H2v-2h20v2ZM22 17H2v-2h20v2Z"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9h2V7h2V5h-2V3h-2v2H9v2h2v2Z"
  }));
};
AddTrackAbove.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var AddTrackBelow = function AddTrackBelow(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4.04 12h16v-2h-16v2Zm0-6v2h16V6h-16ZM13 14h-2v6h2v-6Z"
  }), React__default.createElement("path", {
    d: "M9 16v2h6v-2H9Z"
  }));
};
AddTrackBelow.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MergeTrack = function MergeTrack(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.536 11 7 17l3.464-6H8V6H6v5H3.536ZM22 6H2V4h20v2ZM20.464 13 17 7l-3.464 6H16v5h2v-5h2.464ZM2 18h20v2H2v-2Z"
  }));
};
MergeTrack.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var SplitTrack = function SplitTrack(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.536 17 12 23l3.464-6H13v-2h9v-2H2v2h9v2H8.536ZM15.464 7 12 1 8.536 7H11v2H2v2h20V9h-9V7h2.464Z"
  }));
};
SplitTrack.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Back1 = function Back1(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m18.408 7.583-1.45 8.727h-1.844l1.159-6.976h-.051l-2.208 1.253.273-1.636 2.386-1.368h1.735ZM4 12l4-3v2h4v2H8v2l-4-3Z"
  }));
};
Back1.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Back10 = function Back10(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m2 11.76 4-3v2h4v2H6v2l-4-3ZM14.31 8.1v7.43h-1.57V9.59h-.04L11 10.66V9.27l1.84-1.16h1.48l-.01-.01ZM18.99 15.68c-.62 0-1.16-.16-1.61-.46-.45-.31-.79-.75-1.03-1.32-.24-.58-.36-1.27-.36-2.08s.12-1.5.36-2.07c.24-.57.59-1.01 1.03-1.3.45-.3.98-.45 1.6-.45.62 0 1.16.15 1.6.45.45.3.79.73 1.04 1.3.24.57.36 1.26.36 2.07 0 .81-.12 1.51-.36 2.09-.24.58-.58 1.02-1.03 1.32-.45.31-.98.46-1.61.46l.01-.01Zm0-1.3c.42 0 .76-.21 1.02-.64.25-.43.38-1.07.38-1.93 0-.56-.06-1.03-.17-1.41-.11-.38-.28-.66-.49-.85-.21-.19-.46-.28-.74-.28-.42 0-.76.21-1.02.63-.25.42-.38 1.06-.38 1.9 0 .57.06 1.05.17 1.43.11.38.28.67.49.86.21.19.46.28.74.28v.01Z"
  }));
};
Back10.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Camera = function Camera(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M3.04 6v12h14V6h-14Zm12 10h-10V8h10v8Z"
  }), React__default.createElement("path", {
    d: "m21.04 7-6 5 6 5V7Z"
  }));
};
Camera.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var FastForward = function FastForward(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4 18V6l9 6-9 6Zm7 0V6l9 6-9 6Zm-5-3.75L9.4 12 6 9.75v4.5Zm7 0L16.4 12 13 9.75v4.5Z"
  }));
};
FastForward.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Forward1 = function Forward1(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m10.538 7.583-1.45 8.727H7.245l1.159-6.976H8.35l-2.207 1.253.273-1.636 2.386-1.368h1.735ZM20 12l-4-3v2h-4v2h4v2l4-3Z"
  }));
};
Forward1.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Forward10 = function Forward10(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M5.31 8.1v7.43H3.74V9.59H3.7L2 10.66V9.27l1.84-1.16h1.48l-.01-.01ZM9.99 15.68c-.62 0-1.16-.16-1.61-.46-.45-.31-.79-.75-1.03-1.32-.24-.58-.36-1.27-.36-2.08s.12-1.5.36-2.07c.24-.57.59-1.01 1.03-1.3.45-.3.98-.45 1.6-.45.62 0 1.16.15 1.6.45.45.3.79.73 1.04 1.3.24.57.36 1.26.36 2.07 0 .81-.12 1.51-.36 2.09-.24.58-.58 1.02-1.03 1.32-.45.31-.98.46-1.61.46l.01-.01Zm0-1.3c.42 0 .76-.21 1.02-.64.25-.43.38-1.07.38-1.93 0-.56-.06-1.03-.17-1.41-.11-.38-.28-.66-.49-.85-.21-.19-.46-.28-.74-.28-.42 0-.76.21-1.02.63-.25.42-.38 1.06-.38 1.9 0 .57.06 1.05.17 1.43.11.38.28.67.49.86.21.19.46.28.74.28v.01ZM22 11.76l-4-3v2h-4v2h4v2l4-3Z"
  }));
};
Forward10.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Homography = function Homography(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M19.5 9.11c-.43 0-.83.11-1.18.3h-.01l-2.89-2.28a2.5 2.5 0 1 0-4.92-.63c0 .29.05.58.15.84L5.48 12.2a2.5 2.5 0 1 0 .78 4.08l3.24 1.3C9.54 18.92 10.65 20 12 20s2.5-1.12 2.5-2.5c0-.22-.03-.43-.08-.63l3.89-3.06a2.5 2.5 0 1 0 1.19-4.7Zm-2.42 3.13-3.89 3.06a2.512 2.512 0 0 0-2.95.42L7 14.42c-.01-.27-.06-.52-.15-.76l5.17-4.86a2.488 2.488 0 0 0 2.16-.1l2.89 2.28c-.05.2-.08.41-.08.63s.03.43.08.63Z"
  }));
};
Homography.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Pause = function Pause(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M14 18V6h2v12h-2Zm-6 0V6h2v12H8Z"
  }));
};
Pause.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Play = function Play(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M8 5v14l11-7Zm2 3.64L15.27 12 10 15.36Z"
  }));
};
Play.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ResetHomography = function ResetHomography(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M20.69 8.49c-.41.78-1.11 1.3-1.9 1.5l-.21 2.21c-.66-.18-1.33-.24-1.99-.18l.2-2.22s-.1-.04-.15-.07a2.92 2.92 0 0 1-1.5-1.96l-7.91-.89s-.03.07-.05.1c-.3.56-.76.99-1.29 1.25l.74 5.83c.28.05.55.15.82.29.79.42 1.31 1.13 1.5 1.93l2.05.2v2.01l-2.25-.21s-.04.09-.06.13a3.002 3.002 0 0 1-4.06 1.24 3.002 3.002 0 0 1 .02-5.3L3.9 8.5c-.26-.05-.53-.14-.78-.28a3.002 3.002 0 0 1-1.23-4.06 3.002 3.002 0 0 1 4.06-1.24c.79.42 1.31 1.16 1.5 1.97l7.9.89s.03-.07.05-.11a3.011 3.011 0 0 1 4.06-1.24c1.46.78 2.01 2.6 1.23 4.06Z"
  }), React__default.createElement("path", {
    d: "M21 18c0 2.21-1.79 4-4 4-1.07 0-2.07-.42-2.83-1.17l.7-.7.72-.72c.37.38.88.59 1.41.59 1.1 0 2-.9 2-2 0-.65-.32-1.23-.8-1.59-.34-.26-.75-.41-1.2-.41-.28 0-.54.06-.78.16s-.45.24-.63.43l.38.38L17 18h-4v-4l1.17 1.17c.6-.59 1.37-1 2.24-1.12a3.828 3.828 0 0 1 1.99.21c1.52.56 2.6 2.02 2.6 3.74Z"
  }));
};
ResetHomography.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ResetToPoint = function ResetToPoint(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M6.36 6.35A7.958 7.958 0 0 1 12.01 4C16.43 4 20 7.58 20 12s-3.57 8-7.99 8c-3.73 0-6.84-2.55-7.73-6h2.08c.82 2.33 3.04 4 5.65 4 3.31 0 6-2.69 6-6s-2.69-6-6-6c-1.66 0-3.14.69-4.22 1.78L11.01 11h-7V4l2.35 2.35Z"
  }), React__default.createElement("path", {
    d: "M14 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
  }));
};
ResetToPoint.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rewind = function Rewind(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M20 18V6l-9 6 9 6Zm-7 0V6l-9 6 9 6Zm5-3.75L14.6 12 18 9.75v4.5Zm-7 0L7.6 12 11 9.75v4.5Z"
  }));
};
Rewind.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Speaker = function Speaker(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M17 20.72 8.73 16H2V8h6.73L17 3.28v17.45-.01ZM4 14h5.27L15 17.28V6.72L9.27 10H4v4ZM18.97 6.81v2.55a4 4 0 0 1 1 2.64 4 4 0 0 1-1 2.64v2.55c1.79-1.04 3-2.97 3-5.19s-1.21-4.15-3-5.19Z"
  }));
};
Speaker.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Video = function Video(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M3.04 18h18v-2h-16V7h14v11h2V5h-18"
  }), React__default.createElement("path", {
    d: "m15.54 11.5-6-3.01v6.02l6-3.01ZM15.04 18h-6v2h6v-2Z"
  }));
};
Video.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var VideoAvailable = function VideoAvailable(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M3.04 18h9v-2h-7V7h13v4h2V5h-17"
  }), React__default.createElement("path", {
    d: "m15.04 11.52-6-3.01v6.02l6-3.01ZM22.49 13.41l-5.78 5.79-2.78-2.79L15.34 15l1.37 1.37L21.08 12l1.41 1.41Z"
  }));
};
VideoAvailable.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var VideoDownload = function VideoDownload(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4.04 18.04h8.979v-2H6.035v-9h12.97v5H21v-7H4.04"
  }), React__default.createElement("path", {
    d: "m16.012 11.56-5.986-3.01v6.02l5.986-3.01ZM18.04 21.04l-3-3h2v-4h2v4h2l-3 3Z"
  }));
};
VideoDownload.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var VideoUnavailable = function VideoUnavailable(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M3 17.98h10.3v-2H5v-9h13v3h2v-5H3"
  }), React__default.createElement("path", {
    d: "M15 11.5 9 8.49v6.02l6-3.01ZM22.5 13.41 21.09 12l-2.12 2.12L16.85 12l-1.41 1.41 2.12 2.12-2.25 2.25 1.41 1.41 2.25-2.25 2.25 2.25 1.41-1.41-2.25-2.25 2.12-2.12Z"
  }));
};
VideoUnavailable.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlayerHighlight = function PlayerHighlight(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M7 18H5v5h5v-2H7v-3ZM5 6h2V3h3V1H5v5Zm12 15h-3v2h5v-5h-2v3ZM14 1v2h3v3h2V1h-5ZM12 8.21c-.48 0-.9-.17-1.24-.51-.34-.34-.51-.75-.51-1.24s.17-.9.51-1.24c.34-.34.75-.51 1.24-.51s.9.17 1.24.51c.34.34.51.75.51 1.24s-.17.9-.51 1.24c-.34.34-.75.51-1.24.51Zm-2 11.08v-3.58H9v-4.5c0-.55.2-1.02.59-1.41.39-.39.86-.59 1.41-.59h2c.55 0 1.02.2 1.41.59.39.39.59.86.59 1.41v4.5h-1v3.58h-4Z"
  }));
};
PlayerHighlight.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var GroundingDot = function GroundingDot(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 5.5c-.48 0-.9-.17-1.24-.51-.34-.34-.51-.75-.51-1.24s.17-.9.51-1.24C11.1 2.17 11.51 2 12 2s.9.17 1.24.51c.34.34.51.75.51 1.24s-.17.9-.51 1.24c-.34.34-.75.51-1.24.51Zm-2 11.08V13H9V8.5c0-.55.2-1.02.59-1.41.39-.39.86-.59 1.41-.59h2c.55 0 1.02.2 1.41.59.39.39.59.86.59 1.41V13h-1v3.58h-4ZM12 22.29c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
  }));
};
GroundingDot.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalfMoonLeft = function HalfMoonLeft(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18V4c4.42 0 8 3.58 8 8s-3.58 8-8 8Z"
  }));
};
HalfMoonLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var HalfMoonTop = function HalfMoonTop(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10ZM4 12h16c0 4.42-3.58 8-8 8s-8-3.58-8-8Z"
  }));
};
HalfMoonTop.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Mens = function Mens(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M7.26 8.13h2.28l2.4 5.87H12l2.41-5.87h2.27v8.73h-1.75v-5.68h-.07l-2.26 5.64h-1.22l-2.26-5.66h-.07v5.7H7.26Z",
    style: {
      fill: "#fff"
    }
  }));
};
Mens.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var MensNoLetter = function MensNoLetter(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Z"
  }));
};
MensNoLetter.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PlayerMarkers = function PlayerMarkers(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M8 17.95c.17.02.33.03.49.04.16 0 .33.01.51.01s.35 0 .51-.01c.16 0 .32-.02.49-.04V20h10V10h-2.05c.02-.17.03-.33.04-.49 0-.16.01-.33.01-.51s0-.35-.01-.51c0-.16-.02-.32-.04-.49H22v14H8v-4.05ZM9 16c-1.95 0-3.6-.68-4.96-2.04C2.68 12.6 2 10.95 2 9c0-1.95.68-3.6 2.04-4.96C5.4 2.68 7.05 2 9 2c1.95 0 3.6.68 4.96 2.04C15.32 5.4 16 7.05 16 9c0 1.95-.68 3.6-2.04 4.96C12.6 15.32 10.95 16 9 16Zm0-2c1.38 0 2.56-.49 3.54-1.46C13.51 11.57 14 10.39 14 9c0-1.39-.49-2.56-1.46-3.54C11.56 4.48 10.39 4 9 4c-1.39 0-2.56.49-3.54 1.46S4 7.61 4 9c0 1.39.49 2.56 1.46 3.54S7.61 14 9 14Z"
  }));
};
PlayerMarkers.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlayerTrack = function PlayerTrack(props) {
  return React__default.createElement("svg", props, React__default.createElement("g", {
    clipPath: "url(#clip0_1698_166536)"
  }, React__default.createElement("path", {
    d: "M18 4.92c-.48 0-.9-.17-1.24-.51-.34-.34-.51-.75-.51-1.24s.17-.9.51-1.24c.34-.34.75-.51 1.24-.51s.9.17 1.24.51c.34.34.51.75.51 1.24s-.17.9-.51 1.24c-.34.34-.75.51-1.24.51ZM16 16v-3.58h-1v-4.5c0-.55.2-1.02.59-1.41.39-.39.86-.59 1.41-.59h2c.55 0 1.02.2 1.41.59.39.39.59.86.59 1.41v4.5h-1V16h-4Z"
  }), React__default.createElement("path", {
    d: "M17 18v1h-4V3H5v12.17h2V5h4v16h8v-3"
  }), React__default.createElement("path", {
    d: "M6 15c-1.65 0-3 1.34-3 3s1.35 3 3 3 3-1.34 3-3-1.34-3-3-3Zm.72 3.71c-.2.19-.43.29-.72.29s-.52-.1-.71-.29A.973.973 0 0 1 5 18c0-.28.1-.52.29-.71.19-.19.43-.29.71-.29.28 0 .52.1.72.29.19.19.28.43.28.71 0 .28-.09.52-.28.71Z"
  })));
};
PlayerTrack.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var CircleDot = function CircleDot(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2Z"
  }));
};
CircleDot.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Decimal = function Decimal(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4 18a.99.99 0 0 0 1-1 .99.99 0 0 0-1-1 .99.99 0 0 0-1 1 .99.99 0 0 0 1 1ZM9.5 6C7.57 6 6 7.48 6 9.31v5.39c0 1.83 1.57 3.31 3.5 3.31S13 16.53 13 14.7V9.31C13 7.48 11.43 6 9.5 6Zm1.5 8.69c0 .78-.67 1.42-1.5 1.42S8 15.48 8 14.69V9.3c0-.78.67-1.42 1.5-1.42S11 8.51 11 9.3v5.39ZM17.5 6C15.57 6 14 7.48 14 9.31v5.39c0 1.83 1.57 3.31 3.5 3.31S21 16.53 21 14.7V9.31C21 7.48 19.43 6 17.5 6Zm1.5 8.69c0 .78-.67 1.42-1.5 1.42s-1.5-.63-1.5-1.42V9.3c0-.78.67-1.42 1.5-1.42S19 8.51 19 9.3v5.39Z"
  }));
};
Decimal.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var HeatmapFlame = function HeatmapFlame(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M6 14c0 .87.17 1.69.53 2.46a6.1 6.1 0 0 0 1.5 2.04c-.02-.08-.02-.16-.02-.23v-.23c0-.53.1-1.03.3-1.5.2-.47.49-.89.88-1.27l2.82-2.77 2.82 2.77c.38.38.68.81.88 1.27.2.47.3.97.3 1.5v.23c0 .07 0 .14-.02.23.65-.58 1.15-1.26 1.5-2.04.35-.77.52-1.6.52-2.46s-.15-1.62-.46-2.36a6.13 6.13 0 0 0-1.34-1.99 3.889 3.889 0 0 1-2.17.65c-1.03 0-1.93-.34-2.69-1.02-.76-.68-1.2-1.52-1.31-2.52-.65.55-1.22 1.12-1.72 1.71-.5.59-.92 1.19-1.26 1.8-.34.61-.6 1.23-.78 1.86-.18.63-.26 1.26-.26 1.88Zm6 1.3-1.43 1.4c-.18.18-.32.39-.43.62-.1.23-.15.48-.15.73 0 .53.2.99.59 1.38.39.38.86.57 1.41.57s1.02-.19 1.41-.58c.39-.38.59-.84.59-1.38a1.813 1.813 0 0 0-.58-1.35l-1.43-1.4ZM12 3v3.3c0 .57.2 1.04.59 1.43.39.38.87.57 1.44.57.3 0 .58-.06.84-.19s.49-.31.69-.56l.45-.55a7.68 7.68 0 0 1 2.92 2.93A8.023 8.023 0 0 1 20.01 14c0 2.23-.77 4.12-2.33 5.67-1.55 1.55-3.44 2.33-5.67 2.33s-4.12-.77-5.68-2.33C4.78 18.12 4.01 16.23 4.01 14s.72-4.19 2.16-6.12C7.61 5.95 9.56 4.32 12.01 3Z"
  }));
};
HeatmapFlame.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var PassPath = function PassPath(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22 5-4-3v2.01c-4.685.068-6.79.552-8.773 2.09l1.226 1.58C11.899 6.56 13.426 6.082 18 6.01V8l4-3ZM9.12 8.4c1.12 2.45-.19 5.45-2.93 6.7-.82.38-1.69.56-2.51.54-.1-.16-.2-.33-.28-.51-1.12-2.45.19-5.45 2.93-6.7.82-.38 1.69-.56 2.51-.54.1.16.2.33.28.51Zm6.31 11.75-6.45.66-2.45-4.37 2.84-1.57 1.38 2.46 6.78-.92-2.1 3.74Z"
  }));
};
PassPath.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var Percentile = function Percentile(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M7.5 11c-.97 0-1.79-.34-2.47-1.02S4 8.47 4 7.5s.34-1.79 1.03-2.47S6.54 4 7.5 4s1.79.34 2.48 1.03S11 6.54 11 7.5s-.34 1.79-1.02 2.48S8.47 11 7.5 11Zm0-2c.42 0 .77-.15 1.06-.44.29-.29.44-.65.44-1.06s-.15-.77-.44-1.06C8.27 6.15 7.91 6 7.5 6s-.77.15-1.06.44C6.15 6.73 6 7.09 6 7.5s.15.77.44 1.06c.29.29.65.44 1.06.44Zm9 11c-.97 0-1.79-.34-2.48-1.02-.68-.68-1.02-1.51-1.02-2.48s.34-1.79 1.02-2.48c.68-.68 1.51-1.02 2.48-1.02s1.79.34 2.48 1.02c.68.68 1.02 1.51 1.02 2.48s-.34 1.79-1.02 2.48c-.68.68-1.51 1.02-2.48 1.02Zm0-2c.42 0 .77-.15 1.06-.44.29-.29.44-.65.44-1.06s-.15-.77-.44-1.06c-.29-.29-.65-.44-1.06-.44s-.77.15-1.06.44c-.29.29-.44.65-.44 1.06s.15.77.44 1.06c.29.29.65.44 1.06.44ZM5.4 20 4 18.6 18.6 4 20 5.4 5.4 20Z"
  }));
};
Percentile.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Position = function Position(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
  }), React__default.createElement("path", {
    d: "M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Zm0 14c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Z"
  }), React__default.createElement("path", {
    d: "M2 11h3v2H2zM19 11h3v2h-3zM13 2v3h-2V2zM13 19v3h-2v-3z"
  }));
};
Position.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Radar = function Radar(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "m20.38 2.23 1.36 1.44-1.99 2A9.93 9.93 0 0 1 22 12.1c-.06 5.53-4.58 9.96-10.1 9.9-5.53-.06-9.96-4.58-9.9-10.11C2.06 6.37 6.58 1.94 12.1 2c1.64.02 3.18.43 4.54 1.14l-1.5 1.5c-.94-.4-1.97-.63-3.06-.64C7.67 3.95 4.05 7.5 4 11.91c-.05 4.42 3.5 8.04 7.92 8.09A8.01 8.01 0 0 0 20 12.08a7.95 7.95 0 0 0-1.68-4.99l-1.51 1.52c.68.98 1.07 2.17 1.05 3.45A5.999 5.999 0 0 1 11.8 18a5.999 5.999 0 0 1-5.93-6.07 5.984 5.984 0 0 1 7.67-5.69L11.78 8a4.005 4.005 0 0 0-3.92 3.95A4.014 4.014 0 0 0 11.82 16a4 4 0 0 0 4.04-3.96c.01-.72-.17-1.39-.5-1.98l-1.54 1.54a2 2 0 0 1-1.98 2.4c-1.1-.02-1.99-.92-1.98-2.02.02-1.11.92-1.99 2.03-1.98.21 0 .41.04.6.09l7.89-7.86Z"
  }));
};
Radar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ShotsFaced = function ShotsFaced(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M3 3v6.36c.56-.71 1.24-1.33 2-1.84V5h14v8h2V3H3Z"
  }), React__default.createElement("path", {
    d: "M10 8c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7ZM8.95 19.88l-.71-2.19H5.8c-.48-.75-.77-1.64-.79-2.6L7 13.64l-.66-2.03c.46-.5 1.01-.9 1.64-1.18L10 11.9l2.02-1.47c.63.28 1.18.69 1.64 1.18L13 13.64l1.99 1.45c-.02.96-.31 1.85-.79 2.6h-2.44l-.71 2.19c-.34.07-.69.12-1.05.12s-.71-.04-1.05-.12Z"
  }), React__default.createElement("path", {
    d: "m12 14.35-2-1.45-2 1.45.76 2.35h2.48l.76-2.35z"
  }));
};
ShotsFaced.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var ShotMap = function ShotMap(props) {
  return React__default.createElement("svg", props, React__default.createElement("circle", {
    cx: "6",
    cy: "7",
    r: "1"
  }), React__default.createElement("path", {
    d: "M2 3v7c-.55 0-1 .45-1 1s.45 1 1 1v1h4.29c1.09 2.35 3.43 4 5.83 4s4.51-1.59 5.58-4h4.29V3H2Zm10.13 12c-1.33 0-2.68-.8-3.55-2h6.86c-.74 1.12-1.89 2-3.32 2ZM20 11H4V5h16v6Z"
  }), React__default.createElement("circle", {
    cx: "15",
    cy: "10",
    r: "1"
  }), React__default.createElement("circle", {
    cx: "5",
    cy: "19",
    r: "1"
  }), React__default.createElement("circle", {
    cx: "18",
    cy: "8",
    r: "1"
  }), React__default.createElement("circle", {
    cx: "14",
    cy: "18",
    r: "1"
  }), React__default.createElement("circle", {
    cx: "17",
    cy: "21",
    r: "1"
  }), React__default.createElement("circle", {
    cx: "20",
    cy: "18",
    r: "1"
  }));
};
ShotMap.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var TableView = function TableView(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M1 17h6v2H1zM1 5h6v2H1zM1 9h6v2H1zM1 13h6v2H1zM9 17h6v2H9zM9 5h6v2H9zM9 9h6v2H9zM9 13h6v2H9zM17 17h6v2h-6zM17 5h6v2h-6zM17 9h6v2h-6zM17 13h6v2h-6z"
  }));
};
TableView.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var ViolinPlot = function ViolinPlot(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M2 10.07V11h20v-.94c-.63-.05-3.41-1.41-4-1.41s-1.22.94-2 .94-1.37-1.88-2-1.88c-.34 0-1.04-.94-2-.94-1.45 0-.94-1.88-2-1.88-.54 0-1.27-1.88-2-1.88S6.43 7.25 6 7.25c-.34 0-1.19 2.82-2 2.82H2ZM22 19.94V21H2v-1.07c.63-.06 3.41-1.6 4-1.6s1.22 1.07 2 1.07 1.37-3.2 2-3.2c.34 0 1.04 1.07 2 1.07 1.45 0 .94-4.27 2-4.27.54 0 1.27 2.13 2 2.13s1.57-.53 2-.53c.34 0 1.19 4.27 2 4.27s2 1.07 2 1.07Z"
  }));
};
ViolinPlot.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var Womens = function Womens(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Z"
  }), React__default.createElement("path", {
    className: "svg-fill",
    d: "M8.5 16.86 6 8.13h2l1.46 6.07h.08l1.59-6.07h1.73l1.59 6.08h.07L16 8.13h2l-2.5 8.73h-1.81L12 11.16l-1.66 5.7Z"
  }));
};
Womens.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var WomensNoLetter = function WomensNoLetter(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    className: "svg-fill",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Z"
  }));
};
WomensNoLetter.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var WidgetSizeLandscape = function WidgetSizeLandscape(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4 4v7h16V4H4ZM15.5 18.5V20H13v-2.5h1.5v1h1zM20 17.5V20h-2.5v-1.5h1v-1H20zM20 13v2.5h-1.5v-1h-1V13H20zM15.5 13v1.5h-1v1H13V13h2.5zM11 13v2.5H9.5v-1h-1V13H11zM11 17.5V20H8.5v-1.5h1v-1H11zM6.5 18.5V20H4v-2.5h1.5v1h1zM6.5 13v1.5h-1v1H4V13h2.5z"
  }));
};
WidgetSizeLandscape.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var WidgetSizePortrait = function WidgetSizePortrait(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M20 8.5V11h-2.5V9.5h1v-1H20zM20 4v2.5h-1.5v-1h-1V4H20zM15.5 4v1.5h-1v1H13V4h2.5zM15.5 9.5V11H13V8.5h1.5v1h1zM4 4v16h7V4H4ZM15.5 18.5V20H13v-2.5h1.5v1h1zM20 17.5V20h-2.5v-1.5h1v-1H20zM20 13v2.5h-1.5v-1h-1V13H20zM15.5 13v1.5h-1v1H13V13h2.5z"
  }));
};
WidgetSizePortrait.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var WidgetSizeSquareLarge = function WidgetSizeSquareLarge(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M4 4v16h16V4H4Z"
  }));
};
WidgetSizeSquareLarge.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var WidgetSizeSquareSmall = function WidgetSizeSquareSmall(props) {
  return React__default.createElement("svg", props, React__default.createElement("path", {
    d: "M20 8.5V11h-2.5V9.5h1v-1H20zM20 4v2.5h-1.5v-1h-1V4H20zM15.5 4v1.5h-1v1H13V4h2.5zM15.5 9.5V11H13V8.5h1.5v1h1zM4 4v7h7V4H4ZM15.5 18.5V20H13v-2.5h1.5v1h1zM20 17.5V20h-2.5v-1.5h1v-1H20zM20 13v2.5h-1.5v-1h-1V13H20zM15.5 13v1.5h-1v1H13V13h2.5zM11 13v2.5H9.5v-1h-1V13H11zM11 17.5V20H8.5v-1.5h1v-1H11zM6.5 18.5V20H4v-2.5h1.5v1h1zM6.5 13v1.5h-1v1H4V13h2.5z"
  }));
};
WidgetSizeSquareSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var icons = {
  AccountSettings: AccountSettings,
  ActivateUser: ActivateUser,
  AddToList: AddToList,
  AddTrackAbove: AddTrackAbove,
  AddTrackBelow: AddTrackBelow,
  Admin: Admin,
  Analysis: Analysis,
  Api: Api,
  Apps: Apps,
  Assign: Assign,
  Back1: Back1,
  Back10: Back10,
  BackArrow: BackArrow,
  BallBasketball: BallBasketball,
  BallFootballCollege: BallFootballCollege,
  BallFootballCollegeMultiple: BallFootballCollegeMultiple,
  BallFootballNfl: BallFootballNfl,
  BallFootballNflMultiple: BallFootballNflMultiple,
  BallSoccer: BallSoccer,
  BallSoccerMultiple: BallSoccerMultiple,
  BlockStop: BlockStop,
  Camera: Camera,
  Changelog: Changelog,
  Checklist: Checklist,
  ChevronDown: ChevronDown,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  ChevronUp: ChevronUp,
  CircleDot: CircleDot,
  Clone: Clone,
  Close: Close,
  CloseFullscreen: CloseFullscreen,
  CloseSolid: CloseSolid,
  Collapse: Collapse,
  Comment: Comment,
  Completed: Completed,
  Crosshair: Crosshair,
  Cursor: Cursor,
  Dashboard: Dashboard,
  Date: Date,
  Decimal: Decimal,
  Delete: Delete,
  DisplaySettings: DisplaySettings,
  DoubleChevronLeft: DoubleChevronLeft,
  DoubleChevronRight: DoubleChevronRight,
  Download: Download,
  DragHandle: DragHandle,
  Edit: Edit,
  Email: Email,
  EnterFullscreen: EnterFullscreen,
  Erase: Erase,
  Expand: Expand,
  Faq: Faq,
  FastForward: FastForward,
  Filter: Filter,
  First: First,
  Folder: Folder,
  Forward: Forward,
  Forward1: Forward1,
  Forward10: Forward10,
  ForwardArrow: ForwardArrow,
  Goalkeeper: Goalkeeper,
  GroundingDot: GroundingDot,
  HalfMoonLeft: HalfMoonLeft,
  HalfMoonTop: HalfMoonTop,
  HamburgerMenu: HamburgerMenu,
  Handle: Handle,
  HeatmapFlame: HeatmapFlame,
  Home: Home,
  Homography: Homography,
  Info: Info,
  Injury: Injury,
  InProgress: InProgress,
  IqScout: IqScout,
  IqTactics: IqTactics,
  Key: Key,
  LanguageWorld: LanguageWorld,
  Last: Last,
  League: League,
  Link: Link,
  ListItems: ListItems,
  ListView: ListView,
  Loading: Loading,
  Lock: Lock,
  LogOut: LogOut,
  MatchFootball: MatchFootball,
  MatchSoccer: MatchSoccer,
  MatchSportsAgnostic: MatchSportsAgnostic,
  Mens: Mens,
  MensNoLetter: MensNoLetter,
  MergeTrack: MergeTrack,
  Minus: Minus,
  MissedPenalty: MissedPenalty,
  Mode: Mode,
  More: More,
  MorningShift: MorningShift,
  MultipleRedCard: MultipleRedCard,
  MultipleShotsOffTarget: MultipleShotsOffTarget,
  MultipleShotsOnTarget: MultipleShotsOnTarget,
  MultipleSubstitution: MultipleSubstitution,
  MultipleYellowCard: MultipleYellowCard,
  NightShift: NightShift,
  NotStarted: NotStarted,
  OvernightShift1: OvernightShift1,
  OvernightShift2: OvernightShift2,
  PassPath: PassPath,
  Password: Password,
  Paste: Paste,
  Pause: Pause,
  Pegman: Pegman,
  PegmanPickedUp: PegmanPickedUp,
  Percentile: Percentile,
  PitchAllLandscape: PitchAllLandscape,
  PitchAllPortrait: PitchAllPortrait,
  PitchAttackingHalfLandscape: PitchAttackingHalfLandscape,
  PitchAttackingHalfPortrait: PitchAttackingHalfPortrait,
  PitchAttackingThirdLandscape: PitchAttackingThirdLandscape,
  PitchAttackingThirdPortrait: PitchAttackingThirdPortrait,
  PitchDefensiveHalfLandscape: PitchDefensiveHalfLandscape,
  PitchDefensiveHalfPortrait: PitchDefensiveHalfPortrait,
  PitchDefensiveThirdLandscape: PitchDefensiveThirdLandscape,
  PitchDefensiveThirdPortrait: PitchDefensiveThirdPortrait,
  Play: Play,
  PlayerFootball: PlayerFootball,
  PlayerHighlight: PlayerHighlight,
  PlayerList: PlayerList,
  PlayerMarkers: PlayerMarkers,
  Players: Players,
  PlayerSoccer: PlayerSoccer,
  PlayerTrack: PlayerTrack,
  Playlist: Playlist,
  PlusAdd: PlusAdd,
  PlusSolid: PlusSolid,
  PopoutVideo: PopoutVideo,
  Position: Position,
  PowerProductivity: PowerProductivity,
  Print: Print,
  Priorities: Priorities,
  Profile: Profile,
  QAndA: QAndA,
  QualityIssue: QualityIssue,
  QualityScore: QualityScore,
  Radar: Radar,
  Reassign: Reassign,
  RedCard: RedCard,
  Redo: Redo,
  Refresh: Refresh,
  Remove: Remove,
  Reorder: Reorder,
  Replace: Replace,
  Reset: Reset,
  ResetHomography: ResetHomography,
  ResetToPoint: ResetToPoint,
  ResetZoom: ResetZoom,
  Rewind: Rewind,
  Rotate: Rotate,
  RotateLeft: RotateLeft,
  RotateRight: RotateRight,
  Save: Save,
  SaveAs: SaveAs,
  ScheduleCalendarView: ScheduleCalendarView,
  Search: Search,
  Settings: Settings,
  Share: Share,
  ShotMap: ShotMap,
  ShotsFaced: ShotsFaced,
  ShotsOffTarget: ShotsOffTarget,
  ShotsOnTarget: ShotsOnTarget,
  SortAscending: SortAscending,
  SortDescending: SortDescending,
  SortNone: SortNone,
  Speaker: Speaker,
  SplitTrack: SplitTrack,
  Squad: Squad,
  StarFilled: StarFilled,
  Start: Start,
  StartingEleven: StartingEleven,
  StarUnfilled: StarUnfilled,
  Stopwatch: Stopwatch,
  Substitution: Substitution,
  Success: Success,
  Support: Support,
  Swap: Swap,
  SwapOrientation: SwapOrientation,
  TableView: TableView,
  TeamFootball: TeamFootball,
  TeamSoccer: TeamSoccer,
  ThreeSixty: ThreeSixty,
  ThumbDown: ThumbDown,
  ThumbUp: ThumbUp,
  TickDone: TickDone,
  TiltDown: TiltDown,
  TiltUp: TiltUp,
  TrimArea: TrimArea,
  Tune: Tune,
  Undo: Undo,
  Unlock: Unlock,
  Upload: Upload,
  Video: Video,
  VideoAvailable: VideoAvailable,
  VideoDownload: VideoDownload,
  VideoUnavailable: VideoUnavailable,
  ViolinPlot: ViolinPlot,
  Visibility: Visibility,
  Warning: Warning,
  WidgetSizeLandscape: WidgetSizeLandscape,
  WidgetSizePortrait: WidgetSizePortrait,
  WidgetSizeSquareLarge: WidgetSizeSquareLarge,
  WidgetSizeSquareSmall: WidgetSizeSquareSmall,
  Womens: Womens,
  WomensNoLetter: WomensNoLetter,
  YellowCard: YellowCard,
  ZoomIn: ZoomIn,
  ZoomOut: ZoomOut
};

export { AccountSettings, ActivateUser, AddToList, AddTrackAbove, AddTrackBelow, Admin, Analysis, Api, Apps, Assign, Back1, Back10, BackArrow, BallBasketball, BallFootballCollege, BallFootballCollegeMultiple, BallFootballNfl, BallFootballNflMultiple, BallSoccer, BallSoccerMultiple, BlockStop, Camera, Changelog, Checklist, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, CircleDot, Clone, Close, CloseFullscreen, CloseSolid, Collapse, Comment, Completed, Crosshair, Cursor, Dashboard, Date, Decimal, Delete, DisplaySettings, DoubleChevronLeft, DoubleChevronRight, Download, DragHandle, Edit, Email, EnterFullscreen, Erase, Expand, Faq, FastForward, Filter, First, Folder, Forward, Forward1, Forward10, ForwardArrow, Goalkeeper, GroundingDot, HalfMoonLeft, HalfMoonTop, HamburgerMenu, Handle, HeatmapFlame, Home, Homography, InProgress, Info, Injury, IqScout, IqTactics, Key, LanguageWorld, Last, League, Link, ListItems, ListView, Loading, Lock, LogOut, MatchFootball, MatchSoccer, MatchSportsAgnostic, Mens, MensNoLetter, MergeTrack, Minus, MissedPenalty, Mode, More, MorningShift, MultipleRedCard, MultipleShotsOffTarget, MultipleShotsOnTarget, MultipleSubstitution, MultipleYellowCard, NightShift, NotStarted, OvernightShift1, OvernightShift2, PassPath, Password, Paste, Pause, Pegman, PegmanPickedUp, Percentile, PitchAllLandscape, PitchAllPortrait, PitchAttackingHalfLandscape, PitchAttackingHalfPortrait, PitchAttackingThirdLandscape, PitchAttackingThirdPortrait, PitchDefensiveHalfLandscape, PitchDefensiveHalfPortrait, PitchDefensiveThirdLandscape, PitchDefensiveThirdPortrait, Play, PlayerFootball, PlayerHighlight, PlayerList, PlayerMarkers, PlayerSoccer, PlayerTrack, Players, Playlist, PlusAdd, PlusSolid, PopoutVideo, Position, PowerProductivity, Print, Priorities, Profile, QAndA, QualityIssue, QualityScore, Radar, Reassign, RedCard, Redo, Refresh, Remove, Reorder, Replace, Reset, ResetHomography, ResetToPoint, ResetZoom, Rewind, Rotate, RotateLeft, RotateRight, Save, SaveAs, ScheduleCalendarView, Search, Settings, Share, ShotMap, ShotsFaced, ShotsOffTarget, ShotsOnTarget, SortAscending, SortDescending, SortNone, Speaker, SplitTrack, Squad, StarFilled, StarUnfilled, Start, StartingEleven, Stopwatch, Substitution, Success, Support, Swap, SwapOrientation, TableView, TeamFootball, TeamSoccer, ThreeSixty, ThumbDown, ThumbUp, TickDone, TiltDown, TiltUp, TrimArea, Tune, Undo, Unlock, Upload, Video, VideoAvailable, VideoDownload, VideoUnavailable, ViolinPlot, Visibility, Warning, WidgetSizeLandscape, WidgetSizePortrait, WidgetSizeSquareLarge, WidgetSizeSquareSmall, Womens, WomensNoLetter, YellowCard, ZoomIn, ZoomOut, icons as default };
//# sourceMappingURL=index.js.map
